import Phaser from 'Phaser';
import regeneratorRuntime from "regenerator-runtime";
// const Stripe = require('stripe-checkout');
import * as firebase from 'firebase/app';
import * as utility from '../../modules/utility';
import "firebase/auth";
import "firebase/firestore";
let $ = require( 'jquery' );

import { Request } from 'httprequest';
import GameScene from '../Game/GameScene';
import WizardTowerScene from '../WizardTower/WizardTowerScene';

// Import Spine files
import workerJson from '../../assets/animations/worker.json';
import workerAtlas from '../../assets/animations/worker.txt';
import foxgloveJson from '../../assets/animations/foxglove.json';
import foxgloveAtlas from '../../assets/animations/foxglove.txt';
import lavenderJson from '../../assets/animations/lavender.json';
import lavenderAtlas from '../../assets/animations/lavender.txt';
import strawberryJson from '../../assets/animations/strawberry.json';
import strawberryAtlas from '../../assets/animations/strawberry.txt';
import echinaceaJson from '../../assets/animations/echinacea.json';
import echinaceaAtlas from '../../assets/animations/echinacea.txt';

// import cathedralOfWaxAndHoney from '../../assets/audio/cathedralOfWaxAndHoney.mp3';
// import ambientMusic from '../../assets/audio/monarchiesAmbient.mp3';

class LobbyScene extends Phaser.Scene {
  constructor() {
    super({ key: 'Lobby' });

  }

  preload()
  {
        // Store stuff
        let store = document.getElementById("storeModal");
        if (!this.userData)
        {
            document.getElementById('loggedInAs').hidden = true;
            // document.getElementById('store').hidden = true;
        }

        if (location.protocol != 'https:')
        {
            console.log("Not Secure");
        }

        // Remove GameScene if it's currently running.
        if (this.scene.manager.getIndex('Game') > 0 )
        {
            this.scene.manager.stop('Game');

            // Unhide main menu.
            var mainMenu = document.getElementById('mainMenu');
            mainMenu.hidden = false;

            // Hide alert.
            var disconnectedAlert;
            disconnectedAlert = document.getElementById('disconnectedAlert');
        }

        // Set email value to any previously entered email.
        let previouslyEnteredEmail = localStorage.getItem('email');
        if (previouslyEnteredEmail == '')
        {
            document.getElementById("loginEmailInput").value = previouslyEnteredEmail;
        }

        // Set colonyName value to any previously entered colonyName.
        let previouslyEnteredColonyName = localStorage.getItem("colonyName");
        if (previouslyEnteredColonyName != '' && document.getElementById("colonyName"))
        {
            document.getElementById("colonyName").value = previouslyEnteredColonyName;
        }

        // Define Variables and Arrays
        this.queenBees = [];
        this.queenBeesGroup = this.physics.add.group();
        this.queenBeeEggLaysGroup = this.physics.add.group();
        this.queenBeeBotsGroup = this.physics.add.group();
        this.workers = [];
        this.workersGroup = this.physics.add.group();
        this.workersGroup.setDepth(1);
        this.workerRoles = ['forager', 'nurse', 'builder'];
        this.workerSelectionSpritesGroup = this.physics.add.group();

        this.hives = [];
        this.hivesGroup = this.physics.add.group();
        this.cells = [];
        this.cellsGroup = this.physics.add.group();
        this.cellsThatCanBeBuiltUponVerticallyGroup = this.physics.add.group();
        this.cellsThatCanBeBuiltUponToTheLeftGroup = this.physics.add.group();
        this.cellsThatCanBeBuiltUponToTheRightGroup = this.physics.add.group();

        this.broods = [];
        this.broodsGroup = this.physics.add.group();

        this.greenSpaces = [];
        this.greenSpacesGroup = this.physics.add.group();

        this.plants = [];
        this.plantsGroup = this.physics.add.group();
        this.speciesOfPlant = ['lavender', 'strawberry', 'foxglove', 'echinacea'];

        this.logs = [];
        this.logsGroup = this.physics.add.group();

        this.boulders = [];
        this.bouldersGroup = this.physics.add.group();
        this.boulderSprites = ['boulder1.png', 'boulder2.png', 'boulder3.png', 'boulder4.png', 'boulder5.png', 'boulder6.png'];

        this.pollens = [];
        this.pollensGroup = this.physics.add.group();

        this.honeysGroup = this.physics.add.group();

        this.beeBreads = [];
        this.beeBreadsGroup = this.physics.add.group();

        this.wasps = [];
        this.waspsGroup = this.physics.add.group();

        this.cursors;
        this.fadeCamera;
        this.cameraArray = [];

        this.uiGroup = this.physics.add.group();

        // Load Spine animations
        this.load.spine('worker', workerJson, workerAtlas);
        this.load.spine('foxglove', foxgloveJson, foxgloveAtlas);
        this.load.spine('lavender', lavenderJson, lavenderAtlas);
        this.load.spine('strawberry', strawberryJson, strawberryAtlas);
        this.load.spine('echinacea', echinaceaJson, echinaceaAtlas);

        this.challengeLevelData = [
            { level: 1, metric: "workers", goal: 15, displayGoal: 'Race to<br>15 workers', description: "Reach 15 workers before they do.", reward: 5, numberOfQueenBeeBots: 2 },
            { level: 2, metric: "yellowjackets", goal: 0, displayGoal: 'Defeat<br>yellow jackets', description: "Starts with 2.", reward: 10, numberOfYellowJacketsPerSpawn: 2 },
            { level: 3, metric: "queenBees", goal: 1, displayGoal: 'Defeat<br>queen bees', description: "Eliminate 3 other colonies.", reward: 15, numberOfQueenBeeBots: 3 },
            { level: 4, metric: "yellowjackets", goal: 0, displayGoal: 'Defeat<br>yellow jackets', description: "Starts with 3.", reward: 20, numberOfYellowJacketsPerSpawn: 3 },
            { level: 5, metric: "queenBees", goal: 1, displayGoal: 'Defeat<br>queen bees', description: "Eliminate 6 other colonies.", reward: 25, numberOfQueenBeeBots: 6 },
            { level: 6, metric: "giantWasps", goal: 0, displayGoal: 'Defeat a<br>giant wasp', description: "", reward: 30, numberOfGiantWasps: 1 },
            { level: 7, metric: "wasps", goal: 0, goal2: 0, displayGoal: 'Defeat<br>wasps', description: "Yellowjackets & Giant", reward: 35, numberOfYellowJacketsPerSpawn: 3, numberOfGiantWasps: 1 }
        ];

        this.skinData = [
            { name: 'mellifera', displayName: 'Western Honey Bee<br>(Apis Mellifera)', image: 'worker.png', price: '0' },
            { name: 'bumbleBee', displayName: 'Buff-Tailed Bumble Bee<br>(Bombus Terrestris)', image: 'bumbleBeeWorker.png', price: '100' },
            { name: 'catBee', displayName: 'Cat Bee', image: 'honeyBeeWorkerSkinCat.png', price: '200' },
            { name: 'blueBee', displayName: 'Blue Bee', image: 'honeyBeeWorkerSkinBlue.png', price: '75' },
            { name: 'violetBee', displayName: 'Violet Bee', image: 'honeyBeeWorkerSkinViolet.png', price: '75' },
            { name: 'crown', displayName: 'Crown Bee<br>', image: 'queenBeeCrownSkin.png', price: '1000' },
            { name: 'sweat', displayName: 'Sweat Bee<br>(Augochlorella Aurata)', image: 'sweatBee.png', price: '125' },
            { name: 'fedora', displayName: 'Fedora Hat', image: 'melliferaFedora.png', price: '300' },
            { name: 'partyHat', displayName: 'Party Hat', image: 'melliferaPartyHat.png', price: '300' },
            { name: 'horns', displayName: 'Horns', image: 'melliferaHorns.png', price: '300' },
            { name: 'gasMask', displayName: 'Gas Mask', image: 'melliferaGasMask.png', price: '300' },
            { name: 'threeCorneredHat', displayName: 'Three-Cornered Hat', image: 'melliferaThreeCorneredHat.png', price: '300' }
        ];

        utility.addPluginsToScene(this);

  }

  create()
  {

        this.physics.world.setBounds(0, 0, 3000, 3000);

        // window.onresize = function ()
        // {
        //     // console.log('this', this);
        //     // console.log('GameScene', GameScene)
        //     // Phaser.Game.resize(window.innerWidth, window.innerHeight, 1.0);
        //
        //     LobbyScene.prototype.resizeWindow();
        // }

        this.scale.on('resize', this.resizeScene, this);

        this.cursors = this.input.keyboard.createCursorKeys();

        // Green Spaces
        var numberOfGreenSpaces = 2;
        for (var i = 0; i < numberOfGreenSpaces; i++)
        {
            // var randomPlantSpecie = Phaser.Math.RND.pick(this.speciesOfPlant);
            var x = Phaser.Math.RND.integerInRange(-250,250);
            var y = Phaser.Math.RND.integerInRange(-250,250);

            this.greenSpaces.push( new GreenSpaces(this, x, y) );

        }

        // Logs
        var numberOfLogs = 0;
        for (var i = 0; i < numberOfLogs; i++)
        {
            var x = Phaser.Math.RND.integerInRange(-250,250);
            var y = Phaser.Math.RND.integerInRange(-250,250);
            var angle = Phaser.Math.RND.integerInRange(0,360);
            this.logs.push( new Logs(this, x, y, angle) );
        }

        // Boulders
        var numberOfBoulders = 0;
        for (var i = 0; i < numberOfBoulders; i++)
        {
            var x = Phaser.Math.RND.integerInRange(-250,250);
            var y = Phaser.Math.RND.integerInRange(-250,250);
            var angle = Phaser.Math.RND.integerInRange(0,360);
            this.logs.push( new Boulders(this, x, y, angle) );
        }

        // Texture
        var backgroundTextureSprite = this.add.tileSprite(0, 0, this.physics.world.bounds.width, this.physics.world.bounds.height, 'sprites', 'dustAndScratches.png');
        backgroundTextureSprite.alpha = 1;

        // Hives
        var numberOfStarterHives = 1;
        for(var i = 0; i < numberOfStarterHives; i++)
        {
            var x = Phaser.Math.RND.integerInRange(-250,250);
            var y = Phaser.Math.RND.integerInRange(-250,250);
            this.hives.push( new Hives(this, x, y) );
        }

        // QueenBees
        var x = 0;
        var y = 0;
        this.queenBees.push( new QueenBees(this, x, y) );

        // Workers
        var numberOfStarterWorkers = 5;
        for (var i = 0; i < numberOfStarterWorkers; i++)
        {
            var x = Phaser.Math.RND.integerInRange(-250,250);
            var y = Phaser.Math.RND.integerInRange(-250,250);
            this.workers.push( new Workers(this, x, y) );
        }

        // Set worker selection sprites invisible
        var childrenWorkerSelectionSprites = this.workerSelectionSpritesGroup.getChildren();
        for (var i = 0; i < childrenWorkerSelectionSprites.length; i++)
        {
            childrenWorkerSelectionSprites[i].alpha = 0;
        }

        // Wasps
        var numberOfStarterWasps = 0;
        for(var i = 0; i < numberOfStarterWasps; i++)
        {
            var x = Phaser.Math.RND.integerInRange(-1500,1500);
            var y = Phaser.Math.RND.integerInRange(-1500,1500);
            this.wasps.push( new Wasps(this, x, y) );
        }

        // // Add Colliders // //

        // Workers Collide on stuff.
        this.physics.add.collider(this.workersGroup, this.workersGroup);
        this.physics.add.collider(this.workersGroup, this.queenBeesGroup);
        this.physics.add.collider(this.workersGroup, this.waspsGroup);
        this.physics.add.overlap(this.workersGroup, this.plantsGroup, this.workerTouchedPlant);
        this.physics.add.overlap(this.workersGroup, this.hivesGroup, this.workerTouchedHive);
        this.physics.add.collider(this.workersGroup, this.pollensGroup, this.workerTouchedPollen);
        this.physics.add.overlap(this.workersGroup, this.cellsGroup, this.workerTouchedCell);
        this.physics.add.collider(this.workersGroup, this.beeBreadsGroup, this.workerTouchedBeeBread);
        this.physics.add.overlap(this.workersGroup, this.honeysGroup, this.workerTouchedHoney);
        this.physics.add.overlap(this.workersGroup, this.cellsThatCanBeBuiltUponVerticallyGroup, this.workerTouchedCellThatCanBeBuiltUponVertically);
        this.physics.add.overlap(this.workersGroup, this.cellsThatCanBeBuiltUponToTheRightGroup, this.workerTouchedCellThatCanBeBuiltUponToTheRight);
        this.physics.add.overlap(this.workersGroup, this.cellsThatCanBeBuiltUponToTheLeftGroup, this.workerTouchedCellThatCanBeBuiltUponToTheLeft);
         // Queen bees collide on stuff .
        this.physics.add.collider(this.queenBeesGroup, this.pollensGroup);
        this.physics.add.collider(this.queenBeesGroup, this.beeBreadsGroup);
        this.physics.add.collider(this.queenBeesGroup, this.waspsGroup);
        this.physics.add.overlap(this.queenBeeEggLaysGroup, this.cellsGroup, this.queenBeeEggLayTouchedCell);
        // Pollens collide with each other.
        this.physics.add.collider(this.pollensGroup, this.pollensGroup);
        // Bee bread feeds brood.
        this.physics.add.overlap(this.beeBreadsGroup, this.broodsGroup, this.beeBreadTouchedBrood);

        // Set Depths
        //Lower numbers are on the bottom. Larger numbers are on top of them.
        this.honeysGroup.setDepth(0);
        this.beeBreadsGroup.setDepth(0);
        this.plantsGroup.setDepth(2);
        this.workersGroup.setDepth(3);
        this.queenBeesGroup.setDepth(4);
        this.workerSelectionSpritesGroup.setDepth(100);
        this.uiGroup.setDepth(1000);

        this.hideLoader(this);

        // this.startMusic(this);

        this.setVariablesFromLocalStorage(this);

        this.buildChallengeLevelButtons(this);

        this.unlockChallengeLevels(this);

        this.initializeFirebase(this);

        this.formButtons(this);

        this.loadStripe(this);

    }

    hideLoader(scene)
    {
        var loader = document.getElementById('loader');
        if (loader)
        {
            loader.classList.add('fadeOut');
            setTimeout(function()
            {
                loader.remove();
            }, 500);
        }
    }

    startMusic(scene)
    {
        // Load sound.
        var music = scene.sound.add('cathedralOfWaxAndHoneyMusic');
        music.play();
    }

    setVariablesFromLocalStorage(scene)
    {
        // Solo mode bots
        let numberOfSandboxQueenBeeBotsInput = document.getElementById('numberOfSandboxQueenBeeBotsInput');
        let storedNumberOfSandboxQueenBeeBots = localStorage.getItem('numberOfSandboxQueenBeeBots');
        if (storedNumberOfSandboxQueenBeeBots)
        {
            numberOfSandboxQueenBeeBotsInput.value = storedNumberOfSandboxQueenBeeBots;
        }
        console.log("Number of solo mode bots: ", numberOfSandboxQueenBeeBotsInput.value);
        numberOfSandboxQueenBeeBotsInput.onchange = function()
        {
            console.log("New number of solo mode bots: ", numberOfSandboxQueenBeeBotsInput.value);
            localStorage.setItem('numberOfSandboxQueenBeeBots', numberOfSandboxQueenBeeBotsInput.value);
        };

        // Green Spaces
        let numberOfGreenSpacesInput = document.getElementById('numberOfGreenSpacesInput');
        let storedNumberOfGreenSpaces = localStorage.getItem('numberOfSandboxGreenSpaces');
        if (storedNumberOfGreenSpaces)
        {
            numberOfGreenSpacesInput.value = storedNumberOfGreenSpaces;
        }
        numberOfGreenSpacesInput.onchange = function()
        {
            localStorage.setItem('numberOfSandboxGreenSpaces', numberOfGreenSpacesInput.value);
        };

        // Logs
        let numberOfLogsInput = document.getElementById('numberOfLogsInput');
        let storedNumberOfLogs = localStorage.getItem('numberOfSandboxLogs');
        if (storedNumberOfLogs)
        {
            numberOfLogsInput.value = storedNumberOfLogs;
        }
        numberOfLogsInput.onchange = function()
        {
            localStorage.setItem('numberOfSandboxLogs', numberOfLogsInput.value);
        };

        // Boulders
        let numberOfBouldersInput = document.getElementById('numberOfBouldersInput');
        let storedNumberOfBoulders = localStorage.getItem('numberOfSandboxBoulders');
        if (storedNumberOfBoulders)
        {
            numberOfBouldersInput.value = storedNumberOfBoulders;
        }
        numberOfBouldersInput.onchange = function()
        {
            localStorage.setItem('numberOfSandboxBoulders', numberOfBouldersInput.value);
        };

        // Ponds
        let numberOfPondsInput = document.getElementById('numberOfPondsInput');
        let storedNumberOfPonds = localStorage.getItem('numberOfSandboxPonds');
        if (storedNumberOfPonds)
        {
            numberOfPondsInput.value = storedNumberOfPonds;
        }
        numberOfPondsInput.onchange = function()
        {
            localStorage.setItem('numberOfSandboxPonds', numberOfPondsInput.value);
        };

        // Trees
        let numberOfTreesInput = document.getElementById('numberOfTreesInput');
        let storedNumberOfTrees = localStorage.getItem('numberOfSandboxTrees');
        if (storedNumberOfTrees)
        {
            numberOfTreesInput.value = storedNumberOfTrees;
        }
        numberOfTreesInput.onchange = function()
        {
            localStorage.setItem('numberOfSandboxTrees', numberOfTreesInput.value);
        };

        // Starting Hives
        let numberOfStarterHivesInput = document.getElementById('numberOfStarterHivesInput');
        let storedNumberOfStarterHives = localStorage.getItem('numberOfSandboxStarterHives');
        if (storedNumberOfStarterHives)
        {
            numberOfStarterHivesInput.value = storedNumberOfStarterHives;
        }
        numberOfStarterHivesInput.onchange = function()
        {
            localStorage.setItem('numberOfSandboxStarterHives', numberOfStarterHivesInput.value);
        };

        // Wasp spawn Rate

        let waspSpawnInput = document.getElementById('waspSpawnCheck');
        let storedWaspSpawn = localStorage.getItem('waspSpawnCheck');
        if (storedWaspSpawn == "false")
        {
            waspSpawnInput.checked = false;
        }
        waspSpawnInput.onchange = function()
        {
            localStorage.setItem('waspSpawnCheck', waspSpawnInput.checked);
        };

        // Yellow Jacket Spawn Rate
        // let yellowJacketSpawnRateInput = document.getElementById('yellowJacketSpawnRateInput');
        // let storedYellowJacketSpawnRate = localStorage.getItem('yellowJacketSpawnRate');
        // if (storedYellowJacketSpawnRate)
        // {
        //     yellowJacketSpawnRateInput.value = storedYellowJacketSpawnRate;
        // }
        // yellowJacketSpawnRateInput.onchange = function()
        // {
        //     localStorage.setItem('yellowJacketSpawnRate', yellowJacketSpawnRateInput.value);
        // };
        //
        // // Giant Wasp Spawn Rate
        // let giantWaspSpawnRateInput = document.getElementById('giantWaspSpawnRateInput');
        // let storedGiantWaspSpawnRate = localStorage.getItem('giantWaspSpawnRate');
        // if (storedGiantWaspSpawnRate)
        // {
        //     giantWaspSpawnRateInput.value = storedGiantWaspSpawnRate;
        // }
        // giantWaspSpawnRateInput.onchange = function()
        // {
        //     localStorage.setItem('giantWaspSpawnRate', giantWaspSpawnRateInput.value);
        // };

    }

    // Firebase
    initializeFirebase(scene)
    {
        if (!scene.firebaseInitialized)
        {
            console.log("Intitializing Firebase...");
            var firebaseConfig =
            {
                apiKey: "AIzaSyAUYMDc1yhwX36Fib8E2UML_JO2giXInd0",
                authDomain: "monarchies-1d146.firebaseapp.com",
                databaseURL: "https://monarchies-1d146.firebaseio.com",
                projectId: "monarchies-1d146",
                storageBucket: "monarchies-1d146.appspot.com",
                messagingSenderId: "708610553121",
                appId: "1:708610553121:web:24d5fa070ac9a96e5fba60",
                measurementId: "G-XXCY4NNPP5"
            };
            // Initialize Firebase
            firebase.initializeApp(firebaseConfig);
            scene.firebaseInitialized = true;

            // Log in from stored session if available.
            firebase.auth().onAuthStateChanged(function(user) {
                // console.log("Auth state changed:", user);
                if (user)
                {
                    scene.uid = user.uid;
                    scene.userEmail = user.email;
                    scene.getUserData(scene);
                }
                scene.skinButtons(scene);
            });


        }

    }

    createAccount(scene)
    {
        let email = document.getElementById('createAccountEmailInput');
        let password = document.getElementById('createAccountPasswordInput');
        localStorage.setItem("email", email.value);
        // localStorage.setItem("password", password.value);
        scene.loginType = "email";
        firebase.auth().createUserWithEmailAndPassword(email.value, password.value).then(cred => {
            return firebase.firestore().collection('users').doc(cred.user.uid).set({
                honey: 300,
                workersCreated: 0,
                email: email.value
            });
        }).then(() => {
            let createAccountErrorMessage = document.getElementById('createAccountErrorMessage');
            createAccountErrorMessage.innerHTML = "";
            let closeCreateAccountModalButton = document.getElementById('closeCreateAccountModal');
            closeCreateAccountModalButton.click();
            console.log("Create user success")
        }).catch(function(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            let createAccountErrorMessage = document.getElementById('createAccountErrorMessage');
            createAccountErrorMessage.innerHTML = "Ooh that stings... " + errorMessage;
        });
    }

    loginWithEmail(scene)
    {
        let email = document.getElementById('loginEmailInput');
        let password = document.getElementById('loginPasswordInput');
        localStorage.setItem("email", email.value);
        // localStorage.setItem("password", password.value);
        scene.loginType = "email";
        firebase.auth().signInWithEmailAndPassword(email.value, password.value).then(cred => {
            scene.uid = cred.user.uid;
            scene.userEmail = cred.user.email;
            let loginErrorMessage = document.getElementById('loginErrorMessage');
            loginErrorMessage.innerHTML = "";
            let closeLoginModalButton = document.getElementById('closeLoginModalButton');
            closeLoginModalButton.click();
            scene.getUserData(scene);
            scene.skinButtons(scene);
            console.log("Login success", cred)
        }).catch(function(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            let loginErrorMessage = document.getElementById('loginErrorMessage');
            loginErrorMessage.innerHTML = "Ooh that stings... " + errorMessage;
        });
    }

        // Store Functions

        skinButtons(scene) {

            // Build list of skins.
            let skinList = document.getElementById('skinList');
            skinList.innerHTML = "";
            for (let skin of scene.skinData)
            {
                const capitalName = skin.name.charAt(0).toUpperCase() + skin.name.slice(1);
                skinList.innerHTML +=
                "<div class='col-12 col-sm-4 col-md-4'>" +
                    "<div id='" + skin.name + "' class='skinSelection selectableItem'>" +
                        "<img src='src/assets/individualImages/" + skin.image + "' alt='" + skin.displayName + "'><br>" +
                        "<span class='title'>" +
                            skin.displayName +
                        "</span>" +
                        "<div class='clear'></div>" +
                        "<div id='" + skin.name + "Locked'>" +
                            "<button id='unlock" + capitalName + "Button' type='button' class='button'>" +
                                "Unlock <img src='src/assets/individualImages/honeyOutlineIcon.png' alt='Honey'> " + skin.price +
                            "</button>" +
                        "</div>" +
                    "</div>" +
                "</div>";
            }

            // Set click events of skin unlock buttons.
            for (let skin of scene.skinData)
            {
                // Skin unlock button
                const capitalName = skin.name.charAt(0).toUpperCase() + skin.name.slice(1);
                let unlockButton = document.getElementById("unlock" + capitalName + "Button");
                unlockButton.scene = scene;
                unlockButton.skin = skin;
                unlockButton.onclick = function() {

                    if (scene.userData[this.skin.name] >= 1)
                    {
                        console.log(capitalName, " already unlocked.");

                    } else if (scene.userData.honey >= this.skin.price) {
                        console.log("Trying to add skin ", this.skin.displayName);
                        scene.addSkinToUserAccount(scene, this.skin).then(function(skin) {
                            let skinLocked = document.getElementById(skin.name+'Locked');
                            skinLocked.hidden = true;
                            scene.getUserData(scene);
                        });
                    } else if (scene.userData.honey < 100) {
                        console.log("Not enough honey to unlock bumble bee.");
                    }

                }
            }

            scene.beeSpeciesFormSelect(scene);

        }

        async addSkinToUserAccount(scene, skin)
        {
            scene.userData.honey = scene.userData.honey - skin.price;
            firebase.firestore().collection('users').doc(scene.uid).update({
                honey: scene.userData.honey,
                [skin.name]: 1
            });
            return skin;
        }

        async addMatchToUserAccount(scene) {
            // const payload = {
            //     "matches": 1,
            //     "user_id": scene.client.session.user_id
            // };
            // const rpcid = "addMatchToUserAccount";
            // const addMatch = await scene.client.rpc(scene.client.session, rpcid, payload);
            // // console.log("Sent match add request to server: %o", addMatch);
            // return addMatch;
        }


    formButtons(scene)
    {
        // Sandbox
        let startSandboxButton = document.getElementById('startSandbox');
        startSandboxButton.scene = scene;
        startSandboxButton.onclick = function() {
            startSandbox(scene);
            function startSandbox(scene)
            {
                scene.level = "0";

                // scene.levelType = $("#levelTypeInput").val();
                scene.levelType = 'Game';

                console.log("level type", scene.levelType);

                if(!scene.scene.manager.keys.Game)
                {
                    scene.scene.add('Game', GameScene, false);
                    // scene.scene.add('WizardTower', WizardTowerScene, false);
                }

                // Send user data to GameScene if logged in.
                if (scene.userData)
                {
                    scene.scene.start(scene.levelType, [scene.userData, scene.selectedSpecies, scene.level]);
                } else {
                    scene.scene.start(scene.levelType, [null, null, scene.level]);
                }
            }
        }

        // Challege Levels
        let challengeButtons = document.getElementsByClassName('challengeButton');
        for (let challengeButton of challengeButtons)
        {
            challengeButton.scene = scene;
            challengeButton.onclick = function() {

                // Get the level number.
                let challengeButtonId = challengeButton.id.split("level");
                scene.levelNumber = challengeButtonId[1];
                scene.levelNumber = Number(scene.levelNumber);

                // scene.selectedChallengeLevelData = scene.challengeLevelData.reduce((a, o) => (o.level == scene.levelNumber && a.push(o.value), a), [])
                // scene.selectedChallengeLevelData = scene.challengeLevelData.filter(({ level }) => checked).map(({ value }) => value);
                scene.selectedChallengeLevelData = scene.challengeLevelData.filter(function(challengeLevel) {
                    return challengeLevel.level == scene.levelNumber;
                });
                scene.selectedChallengeLevelData = scene.selectedChallengeLevelData[0];
                console.log("scene.selectedChallengeLevelData", scene.selectedChallengeLevelData[0]);

                // this.challengeLevelData = [
                //     { level: 1, metric: "workers", goal: 15, displayGoal: 'Race to<br>15 workers' },
                //     { level: 2, metric: "yellowJacket", goal: 0, displayGoal: 'Defeat<br>yellow jackets' },
                //     { level: 3, metric: "workers", goal: 0, displayGoal: 'Defeat queen bees' },
                //     { level: 4, metric: "wasp", goal: 0, displayGoal: 'Defeat a giant wasp' }
                // ];

                let localStorageLevelUnlocked = localStorage.getItem("levelUnlocked");
                if (scene.userData && scene.levelNumber <= scene.userData.levelUnlocked ||
                    scene.levelNumber <= localStorageLevelUnlocked ||
                    scene.levelNumber == 1)
                {
                    startChallenge(challengeButton, scene);
                    function startChallenge(challengeButton, scene)
                    {
                        document.getElementById("closeChallengeSelectModal").click();
                        if(!scene.scene.manager.keys.Game)
                        {
                            scene.scene.add('Game', GameScene, false);
                        }
                        // Send user data to GameScene if logged in.
                        if (scene.userData)
                        {
                            scene.scene.start('Game', [scene.userData, scene.selectedSpecies, scene.selectedChallengeLevelData]);
                        } else {
                            scene.scene.start('Game', [null, null, scene.selectedChallengeLevelData]);
                        }
                    }
                }
            }
        }

        // Logins
        let loginWithEmailButton;
        loginWithEmailButton = document.getElementById('loginSubmitLogin');
        loginWithEmailButton.onclick = async function() {
            let email = document.getElementById('loginEmailInput');
            let password = document.getElementById('loginPasswordInput');
            localStorage.setItem("email", email.value);
            scene.loginType = "email";
            scene.loginWithEmail(scene);
            // scene.startSession(scene);
        }

        // Create Account
        let createAccountWithEmailButton;
        createAccountWithEmailButton = document.getElementById('createAccountSubmitLogin');
        createAccountWithEmailButton.onclick = async function() {
            scene.createAccount(scene);
            // scene.startSession(scene);
        }

        // Log out
        try {
            let logOutButton = document.getElementById('logOutButton');
            logOutButton.onclick = async function() {
                console.log("Logging Out...");
                firebase.auth().signOut().then(function() {
                    // Sign-out successful.
                    document.getElementById('notLoggedIn').hidden = false;
                    // document.getElementById('store').hidden = true;
                    document.getElementById('loggedInAs').hidden = true;
                    // let closeProfileModalButton = document.getElementById('closeProfileModal');
                    // closeProfileModalButton.click();
                    location.reload();
                }).catch(function(error) {
                    // An error happened.
                    console.log("An error happened logging out: ", error);
                });
            }
        } catch(e) {
          console.log("An error occured while trying to update account info onto HTML elements: %o", e)
        }

        // // Settings functions // //

        // Toggle Sounds Button
        try {
            let toggleSoundButton = document.getElementById('toggleSoundButton');
            scene.storedSoundDisabled = localStorage.getItem("storedSoundDisabled");
            if (scene.storedSoundDisabled == "true")
            {
                toggleSoundButton.innerHTML = "Sound: Off";
            } else {
                scene.storedSoundDisabled = false;
            }

            toggleSoundButton.onclick = async function() {
                console.log("Toggling Sound...");
                if (scene.storedSoundDisabled)
                {
                    scene.storedSoundDisabled = false;
                    toggleSoundButton.innerHTML = "Sound: On";
                } else {
                    scene.storedSoundDisabled = true;
                    toggleSoundButton.innerHTML = "Sound: Off";
                }
                localStorage.setItem("storedSoundDisabled", scene.storedSoundDisabled);
            }
        } catch(e) {
          console.log("An error occured while trying to toggle animations: %o", e)
        }

        // Toggle Animations Button
        try {
            let toggleAnimationsButton = document.getElementById('toggleAnimationsButton');

            scene.storedAnimationsDisabled = localStorage.getItem("storedAnimationsDisabled");
            if (scene.storedAnimationsDisabled == "true")
            {
                toggleAnimationsButton.innerHTML = "Animations: Off";
            } else {
                scene.storedAnimationsDisabled = false;
            }

            toggleAnimationsButton.onclick = async function() {
                console.log("Toggling Animations...");
                if (scene.storedAnimationsDisabled)
                {
                    scene.storedAnimationsDisabled = false;
                    toggleAnimationsButton.innerHTML = "Animations: On";
                } else {
                    scene.storedAnimationsDisabled = true;
                    toggleAnimationsButton.innerHTML = "Animations: Off";
                }
                localStorage.setItem("storedAnimationsDisabled", scene.storedAnimationsDisabled);
            }
        } catch(e) {
          console.log("An error occured while trying to toggle animations: %o", e)
        }

        // Toggle Virtual Joystick Button
        try {
            let toggleVirtualJoystickButton = document.getElementById('toggleVirtualJoystickButton');
            scene.storedVirtualJoystickEnabled = localStorage.getItem("virtualJoystickEnabled");
            // console.log("vjoy localstorage", scene.storedVirtualJoystickEnabled);
            if (scene.storedVirtualJoystickEnabled == "true")
            {
                console.log("vj localstorage was undefined or true");
                toggleVirtualJoystickButton.innerHTML = "Virtual Joystick: On";
            } else {
                toggleVirtualJoystickButton.innerHTML = "Virtual Joystick: Off";
                scene.storedVirtualJoystickEnabled = false;
            }

            toggleVirtualJoystickButton.onclick = async function() {
                console.log("Toggling Virtual Joystick...");
                scene.storedVirtualJoystickEnabled = !scene.storedVirtualJoystickEnabled;
                if (scene.storedVirtualJoystickEnabled)
                {
                    scene.storedVirtualJoystickEnabled = true;
                    toggleVirtualJoystickButton.innerHTML = "Virtual Joystick: On";
                } else {
                    scene.storedVirtualJoystickEnabled = false;
                    toggleVirtualJoystickButton.innerHTML = "Virtual Joystick: Off";
                }
                localStorage.setItem("virtualJoystickEnabled", scene.storedVirtualJoystickEnabled);
            }
        } catch(e) {
          console.log("An error occured while trying to toggle virtual joystick: %o", e)
        }
    }

    loadStripe(scene) {

        document.getElementById('buyHoneyLoader').hidden = true;

        scene.stripe = Stripe('pk_live_pR1OelxjDh5KBmXZdSiBfkEa');
        console.log("stripe: ", scene.stripe);

        function openStripeCheckout(scene, price, honeyAmount)
        {
            document.getElementById('buyHoneyLoader').hidden = false;
            setTimeout(function() {
                document.getElementById('buyHoneyLoader').hidden = true;
            }, 6000);

            console.log("stripe: ", scene.stripe);
            let description = honeyAmount + ' Honey Points on Monarchies.io for ' + scene.userEmail;
            let purchaseDetails = {};
            purchaseDetails.email = scene.userEmail;
            purchaseDetails.honeyAmount = honeyAmount;
            purchaseDetails.price = price;
            purchaseDetails.description = description;
            purchaseDetails.userId = scene.uid;

            new Request('POST', 'https://monarchies.io/scripts/chargeStripe.php')
                .sendJSON(purchaseDetails, (err, response) => {
                    if (err) throw err;
                    console.log('got response', response);
                    if (response)
                    {
                        scene.stripe.redirectToCheckout({
                            sessionId: response
                          }).then(function (result) {
                            // If `redirectToCheckout` fails due to a browser or network
                            // error, display the localized error message to your customer
                            // using `result.error.message`.
                            console.log("Stripe error:", result);
                          });
                    } else {
                        console.log("Charge unsuccessful.");
                    }
                });

            // scene.stripe({
            //     locale: 'auto',
            //     name: 'Monarchies.io',
            //     description: description,
            //     amount: 1 * price,
            //     email: scene.userEmail,
            //     allowRememberMe: true,
            //     image: 'https://monarchies.io/img/stripeIcon.png'
            // }).then(function(token) {
            //     if (!token) {
            //       console.log('user closed stripe checkout without filling in credentials')
            //       return
            //     }
            //     console.log('Send this token to the server', token, scene);
            //     token.honeyAmount = honeyAmount;
            //     token.price = price;
            //     token.description = description;
            //     new Request('POST', 'https://monarchies.io/scripts/stripe/chargeStripe.php')
            //         .sendJSON(token, (err, response) => {
            //             if (err) throw err;
            //             console.log('got response', response);
            //             let succeeded = response.includes("succeeded");
            //             if (succeeded)
            //             {
            //                 console.log("Charge successful");
            //
            //                 // scene.addHoneyToUserAccount(scene, honeyAmount).then(function(res) {
            //                 //     console.log("Response from adding honey is: ", res)
            //                 //     scene.getUserData(scene).then(function(userData) {
            //                 //         let userWallet = JSON.parse(userData.wallet);
            //                 //         scene.client.wallet = userWallet;
            //                 //         scene.client.email = userData.email;
            //                 //         scene.client.userData = userData;
            //                 //         scene.updateAccountInfoHTMLElements(scene);
            //                 //     });
            //                 // });
            //                 let closeBuyHoneyModal = document.getElementById('closeBuyHoneyModal');
            //                 closeBuyHoneyModal.click();
            //             } else {
            //                 console.log("Charge unsuccessful.");
            //             }
            //         });
            // })

            // let price;
            // switch(honeyAmount)
            // {
            //     case 1000:
            //         price = 'price_1HDfXBBnGJcKjBN8WxkwuevJ';
            //         break;
            //     case 6000:
            //         price = 'price_1HDfXmBnGJcKjBN8i0Z3Bif7';
            //         break;
            //     case 15000:
            //         price = 'price_1HDfYjBnGJcKjBN8s1HacL5V';
            //         break;
            // }
            //
            // scene.stripe.redirectToCheckout({
            //     lineItems: [{price: price, quantity: 1}],
            //     mode: 'payment',
            //     // Do not rely on the redirect to the successUrl for fulfilling
            //     // purchases, customers may not always reach the success_url after
            //     // a successful payment.
            //     // Instead use one of the strategies described in
            //     // https://stripe.com/docs/payments/checkout/fulfillment
            //     successUrl: 'https://monarchies.io/?stripe_success=true',
            //     cancelUrl: 'https://monarchies.io/?stripe_cancelled=true',
            // })
            //   .then(function (result) {
            //       console.log("Stripe result: ", result);
            //       if (result.error) {
            //           // If `redirectToCheckout` fails due to a browser or network
            //           // error, display the localized error message to your customer.
            //           // var displayError = document.getElementById('error-message');
            //           // displayError.textContent = result.error.message;
            //           console.log("Stripe error: ", result.error);
            //       }
            // });


        }

        // Buy Honey Buttons
        if (location.protocol == 'https:' || location.protocol == 'http:')
        {
            let buy1000Honey = document.getElementById("buy1000Honey");
            buy1000Honey.scene = scene;
            buy1000Honey.onclick = function() {
                openStripeCheckout(scene, 1, 1000);
            }
            let buy6000Honey = document.getElementById("buy6000Honey");
            buy6000Honey.scene = scene;
            buy6000Honey.onclick = function() {
                openStripeCheckout(scene, 5, 6000);
            }
            let buy15000Honey = document.getElementById("buy15000Honey");
            buy15000Honey.scene = scene;
            buy15000Honey.onclick = function() {
                openStripeCheckout(scene, 10, 15000);
            }
        }
    }

    beeSpeciesFormSelect(scene) {

        let skinImage = document.getElementById("skinImage");
        scene.skinSelectionElements = {};

        for (let skin of scene.skinData)
        {
            const capitalName = skin.name.charAt(0).toUpperCase() + skin.name.slice(1);
            scene.skinSelectionElements['select'+capitalName] = document.getElementById(skin.name);
            scene.skinSelectionElements['select'+capitalName].scene = scene;
            scene.skinSelectionElements['select'+capitalName].onclick = function() {
                let skinUnlockButton = document.getElementById("unlock"+capitalName+"Button");
                if (scene.userData[skin.name] >= 1 ||
                    skin.name == 'mellifera')
                {
                    scene.deselectBeeSpecies(scene);
                    scene.skinSelectionElements['select'+capitalName].classList.add('selected');
                    scene.selectedSpecies = skin.name;
                    skinImage.src = "src/assets/individualImages/" + skin.image;
                    localStorage.setItem("selectedSkin", skin.name);
                } else {
                    console.log("Skin not unlocked.");
                }
            }
        }

    }

    deselectBeeSpecies(scene) {
        document.getElementById('mellifera').classList.remove('selected');
        document.getElementById('bumbleBee').classList.remove('selected');
        document.getElementById('catBee').classList.remove('selected');
        document.getElementById('blueBee').classList.remove('selected');
        document.getElementById('violetBee').classList.remove('selected');
        document.getElementById('crown').classList.remove('selected');
        document.getElementById('sweat').classList.remove('selected');
    }

    // User Account

    async getUserData(scene) {
        console.log("Getting user data...");
        // Get user account.
        firebase.firestore().collection('users').doc(scene.uid).get().then(userData => {
            scene.userData = userData.data();
            scene.userData.uid = scene.uid;
            console.log("user data:", userData);
            scene.updateAccountInfoHTMLElements(scene);
            return userData;
        });
    }

    updateAccountInfoHTMLElements(scene) {

        try {

            // Set undefined variables to zero.
            if (!scene.userData.honey)
            {
                scene.userData.honey = 0;
            }
            if (!scene.userData.workersCreated)
            {
                scene.userData.workersCreated = 0;
            }
            if (!scene.userData.matches)
            {
                scene.userData.matches = 0;
            }

            // Update HTML elements.
            document.getElementById('notLoggedIn').hidden = true;
            document.getElementById('loggedInAs').hidden = false;
            if (scene.userEmail)
            {
                document.getElementById('profileEmail').innerHTML = "Email: " + scene.userEmail;
                document.getElementById('loggedInAsEmail').innerHTML = scene.userEmail;
            } else if (scene.storedEmail) {
                document.getElementById('profileEmail').innerHTML = "Email: " + scene.storedEmail;
                document.getElementById('loggedInAsEmail').innerHTML = scene.storedEmail;
            }
            // Update profile honey counter
            let profileHoneyElements = document.getElementsByClassName('profileHoney');
            for (let profileHoneyElement of profileHoneyElements)
            {
                profileHoneyElement.innerHTML = "Honey available to spend: <br> <img src='src/assets/individualImages/honeyIcon.png' alt='Honey'>" + " " + scene.userData.honey;
            }
            document.getElementById('profileWorkersCreated').innerHTML = "Workers Created: <br> <img src='src/assets/individualImages/workerIcon.png' alt='Workers Created'>" + " " + scene.userData.workersCreated;

            scene.unlockChallengeLevels(scene);

            scene.unlockSkins(scene);

        } catch(e) {
          console.log("An error occured while trying to update account info onto HTML elements: %o", e)
        }

    }

    unlockSkins(scene)
    {
        try {

            document.getElementById('melliferaLocked').hidden = true;

            for (let skin of scene.skinData)
            {
                if (scene.userData[skin.name] >= 1)
                {
                    let skinLocked = document.getElementById(skin.name+'Locked');
                    skinLocked.hidden = true;
                }
            }

            // Get skin from localStorage
            let storedSkin = localStorage.getItem("selectedSkin");
            if (!storedSkin)
            {
                storedSkin = "mellifera";
            }
            const capitalName = storedSkin.charAt(0).toUpperCase() + storedSkin.slice(1);
            scene.skinSelectionElements['select'+capitalName].click();
        } catch(e) {
        	console.log("There was an error unlocking skins: ", e);
        }

    }

    buildChallengeLevelButtons(scene)
    {
        try {
            let index = 1;
            let challengeLevelHTML = "";
            for (let challenge of scene.challengeLevelData)
            {
                challengeLevelHTML += "<div class='row'>";
                challengeLevelHTML += "<div class='level col-12 col-sm-12 col-md-12'>";
                        challengeLevelHTML += "<button ";
                        challengeLevelHTML += "id='level" + index + "'";
                        challengeLevelHTML += "class='challengeButton hexagon levelContainer ";
                            if (index != 1)
                            {
                                challengeLevelHTML += "lockedLevel";
                            }
                            challengeLevelHTML += " button'>";
                            challengeLevelHTML += "<h5 class='challengeGoal'>";
                                challengeLevelHTML += challenge.displayGoal;
                            challengeLevelHTML += "</h5>";
                            challengeLevelHTML += "<p class='challengeDescription'>";
                                challengeLevelHTML += challenge.description;
                            challengeLevelHTML += "</p>";
                            challengeLevelHTML += "<span>";
                                challengeLevelHTML += challenge.reward;
                                challengeLevelHTML += " <img src='src/assets/individualImages/honeyOutlineIcon.png' alt='Honey' class='challengeHoney'>";
                            challengeLevelHTML += "</span>";


                            if (index != 1)
                            {

                                challengeLevelHTML += "<div class='levelLockedIcon'>";
                                    challengeLevelHTML += "<img src='src/assets/individualImages/lock.png' alt='Level " + index + " Locked'>";
                                challengeLevelHTML += "</div>";
                            }
                        challengeLevelHTML += "</button>";
                    challengeLevelHTML += "</div>";
                challengeLevelHTML += "</div>";
                index++;
            }
            let challengeSelectButtons = document.getElementById("challengeSelectButtons");

            challengeSelectButtons.innerHTML = challengeLevelHTML;
        } catch(e) {
        	console.log("There was an error building out the challenge level buttons: ", e);
        }
    }

    unlockChallengeLevels(scene)
    {
        try {
            let localStorageLevelUnlocked = localStorage.getItem("levelUnlocked");
            localStorageLevelUnlocked = Number(localStorageLevelUnlocked);
            if (scene.userData && scene.userData.levelUnlocked ||
                localStorageLevelUnlocked)
            {
                let lockedLevels = document.getElementsByClassName("lockedLevel");
                for (let lockedLevel of lockedLevels)
                {
                    // If lockedLevel is more than the number on this button,
                    // Hide the lock from the UI.
                    let lockedLevelNumber = lockedLevel.id.split("level")[1];

                    if (scene.userData && lockedLevelNumber <= scene.userData.levelUnlocked ||
                        lockedLevelNumber <= localStorageLevelUnlocked)
                    {
                        let lockedLevelChildren = lockedLevel.children; // Level lock icon
                        lockedLevelChildren[lockedLevelChildren.length - 1].hidden = true;
                        lockedLevel.classList.remove("lockedHexagon");
                        lockedLevel.classList.add("unlockedLevel");
                    }
                }
            }
        } catch (e) {
            console.log("There was an error unlocking challenge levels.", e);
        }
    }

    resizeScene(gameSize, baseSize, displaySize, resolution)
    {
        var width = gameSize.width;
        var height = gameSize.height;

        this.cameras.resize(width, height);
    }


  workerTouchedPlant(worker, plant)
  {
      // Only do this if the worker's target hasn't been changed for awhile.
      if (worker.targetRecentlyChanged == false)
      {

          var maybeThePollenDoesNotSpawn = Phaser.Math.RND.integerInRange(0,3);

          if (maybeThePollenDoesNotSpawn == 0)
          {
              var numberOfPollensToSpawn = 1;
              for (var i = 0; i < numberOfPollensToSpawn; i++)
              {
                  var xVariation = Phaser.Math.RND.integerInRange(-100,100);
                  var yVariation = Phaser.Math.RND.integerInRange(-100,100);

                  worker.scene.pollens.push( new Pollens(worker.scene, plant.x + xVariation, plant.y + yVariation) );
              }
          }

          worker.targetRecentlyChanged = true;

          // Pick a hive to go to after a few seconds.
          var changeTargetToHiveTimer = worker.scene.time.addEvent(
              {
                  delay: 5000,
                  callback: function changeTargetToHive() {
                      worker.target = Phaser.Math.RND.pick(worker.scene.hivesGroup.children.entries);
                      worker.carryingNectar = true;
                  },
                  callbackScope: this,
                  loop: false
              }
          );

          var recentlyChangedTargetTimer = worker.scene.time.addEvent(
              {
                  delay: 10000,
                  callback: function targetNoLongerRecentlyChanged() {
                      worker.targetRecentlyChanged = false;
                  },
                  callbackScope: this,
                  loop: false
              }
          );

      }
  }

  workerTouchedHive(worker, hive)
  {
      if (worker.targetRecentlyChanged == false)
      {
          worker.targetRecentlyChanged = true;

          switch(worker.role)
          {
              case 'forager':
                  worker.target = Phaser.Math.RND.pick(worker.scene.plantsGroup.children.entries);
                  break;
              case 'nurse':
                  if (worker.scene.beeBreadsGroup.children.length > 0)
                  {
                      worker.target = Phaser.Math.RND.pick(worker.scene.beeBreadsGroup.children.entries);
                  }
                  break;
              case 'builder':
                  worker.target = Phaser.Math.RND.pick(worker.scene.cellsThatCanBeBuiltUponVerticallyGroup.children.entries);
                  break;
          }

          var recentlyChangedTargetTimer = worker.scene.time.addEvent(
              {
                  delay: 5000,
                  callback: function targetNoLongerRecentlyChanged() {
                      worker.targetRecentlyChanged = false;
                  },

                  callbackScope: this,
                  loop: false
              }
          );

      }
  }

  workerTouchedPollen(worker, pollen)
  {

          worker.pollenCarriedGroup.add(pollen);
          pollen.scene.pollensGroup.remove(pollen);

          // Set Scene on all children in the pollenCarriedGroup
          // because for some reason that gets unset before we set depth on them.
          var childrenPollens = worker.pollenCarriedGroup.getChildren();
          if (childrenPollens.length > 0)
          {
              for (var i = 0; i < childrenPollens.length; i++)
              {
                  childrenPollens[i].scene = worker.scene;
              }
          }

          worker.pollenCarriedGroup.setDepth(100);
  }

  workerTouchedBeeBread(worker, beeBread)
  {
      if (worker.role == 'nurse')
      {
          worker.targetRecentlyChanged = true;

          worker.beeBreadCarriedGroup.add(beeBread);
          beeBread.scene.beeBreadsGroup.remove(beeBread);

          // Set Scene on all children in the pollenCarriedGroup
          // because for some reason that gets unset before we set depth on them.
          var childrenBeeBreads = worker.beeBreadCarriedGroup.getChildren();
          if (childrenBeeBreads.length > 0)
          {
              for (var i = 0; i < childrenBeeBreads.length; i++)
              {
                  childrenBeeBreads[i].scene = worker.scene;
              }
          }
          worker.beeBreadCarriedGroup.setDepth(100);

          if (worker.scene.broods.length > 0)
          {
              worker.target = Phaser.Math.RND.pick(worker.scene.broodsGroup.children.entries);
              // console.log('A nurse is carrying beeBread to a brood.  new target:', worker.target);

              // console.log("worker.scene.broodsGroup", worker.scene.broodsGroup);

              for (var i = 0; i < worker.scene.broodsGroup.children.entries.length; i++)
              {
                  if (worker.target.broodStage != 'larva')
                  {
                      worker.target = Phaser.Math.RND.pick(worker.scene.broodsGroup.children.entries);
                      // console.log('recalculating target:', worker.target.broodStage);
                  }
              }
          } else if (worker.targetRecentlyChanged == false) {
              var recentlyChangedTargetTimer = worker.scene.time.addEvent(
                  {
                      delay: 5000,
                      callback: function targetNoLongerRecentlyChanged() {
                          worker.targetRecentlyChanged = false;
                      },

                      callbackScope: this,
                      loop: false
                  }
              );
          }
      }
  }

  workerTouchedHoney(worker, honey)
  {
      // Builders eat honey before building a cell.
      if (worker.role == 'builder')
      {
          if (worker.isHungry == true)
          {
              honey.scene.honeysGroup.remove(honey);
              honey.destroy();

              worker.isHungry = false;
              worker.numberOfCellsWorkerCanBuildBeforeEating = 5;

              const cellDirections = ['vertical', 'left, right'];
              var randomCellDirection = Phaser.Math.RND.pick(cellDirections);
              switch (randomCellDirection)
              {
                  case 'vertical':
                      worker.target = Phaser.Math.RND.pick(worker.scene.cellsThatCanBeBuiltUponVerticallyGroup.children.entries);
                      break;
                  case 'left':
                      worker.target = Phaser.Math.RND.pick(worker.scene.cellsThatCanBeBuiltUponToTheLeftGroup.children.entries);
                      break;
                  case 'right':
                      worker.target = Phaser.Math.RND.pick(worker.scene.cellsThatCanBeBuiltUponToTheRightGroup.children.entries);
                      break;
              }
              // console.log('A builder is headed to a buildable cell.  new target:', worker.target);
          }
      }
  }

  beeBreadTouchedBrood(beeBread, brood)
  {
      try {
          if (brood.broodStage == 'larva')
          {
              // console.log('bee bread touched larva', beeBread, brood);

              brood.broodStage = 'pupa';
              brood.setTexture('sprites', 'pupa.png');
              beeBread.scene.beeBreadsGroup.remove(beeBread, true);
              beeBread.destroy();

              var pupaBecomesWorker = brood.scene.tweens.add({
                  targets: brood,
                  alpha: '0',
                  delay: 10000,
                  duration: 250,
                  ease: 'Sine',
                  onComplete: brood.scene.pupaBecomesWorker
              });
          }
      } catch(error)
      {
          console.log("There was an error when bee bread touched brood in the lobby:", error);
      }


  }

  pupaBecomesWorker(tween, targets)
  {

      var newWorker;
      targets[0].scene.workers.push( newWorker = new Workers(targets[0].scene, targets[0].x, targets[0].y) );
      newWorker.workerSprite.scaleX = 0;
      var workerScalesInTween = targets[0].scene.tweens.add({
          targets: newWorker.workerSprite,
          scaleX: '1',
          duration: 500,
          ease: 'Sine'
      });

      targets[0].destroy();
  }

  workerTouchedCell(worker, cell)
  {
          // console.log("worker", worker);
          // console.log("cell", cell);

          switch(cell.typeOfCell)
          {
              case 'empty':
                  var childrenPollens = worker.pollenCarriedGroup.getChildren();
                  if (childrenPollens.length > 0)
                  {
                      cell.typeOfCell = 'pollenStorage';
                      for (var i = 0; i < childrenPollens.length; i++)
                      {
                          var randomVariationX = Phaser.Math.RND.integerInRange(-10, 10);
                          var randomVariationY = Phaser.Math.RND.integerInRange(-10, 10);
                          childrenPollens[i].x = cell.x + randomVariationX;
                          childrenPollens[i].y = cell.y + randomVariationY;
                          cell.pollenStorageGroup.add(childrenPollens[i]);
                          worker.pollenCarriedGroup.remove(childrenPollens[i]);
                          // console.log('childrenPollens.length', childrenPollens.length);
                      }
                  } else if (worker.carryingNectar == true) {
                      worker.carryingNectar = false;
                      cell.typeOfCell = 'honeyStorage';
                      this.honeySprite = cell.scene.physics.add.sprite(cell.x, cell.y, 'sprites', 'honeyCell.png');
                      this.honeySprite.alpha = 0;
                      worker.scene.tweens.add({
                          targets: this.honeySprite,
                          alpha: 1,
                          duration: 1000,
                          ease: 'Sine'
                      });
                      // console.log('this.honeySprite', this.honeySprite);
                      cell.honeyStorageGroup.add(this.honeySprite);
                      cell.scene.honeysGroup.add(this.honeySprite);

                      // this.honeySprite.scene.bringBeesToTop();
                  }
                  break;

              case 'pollenStorage':
                  var childrenPollens = worker.pollenCarriedGroup.getChildren();
                  var maximumPollenInStorage = 20;
                  if (childrenPollens.length > 0 && childrenPollens.length < maximumPollenInStorage)
                  {
                      for (var i = 0; i < childrenPollens.length; i++)
                      {
                          // Pollen gets stored.
                          var randomVariationX = Phaser.Math.RND.integerInRange(-10, 10);
                          var randomVariationY = Phaser.Math.RND.integerInRange(-10, 10);
                          childrenPollens[i].x = cell.x + randomVariationX;
                          childrenPollens[i].y = cell.y + randomVariationY;
                          cell.pollenStorageGroup.add(childrenPollens[i]);
                          worker.pollenCarriedGroup.remove(childrenPollens[i]);
                      }
                  } else {
                      // Bee bread gets made.
                      // console.log('bee bread gets made. childrenPollens.length', childrenPollens.length);
                      cell.typeOfCell = 'empty';
                      for (var i = 0; i < childrenPollens.length; i++)
                      {
                          cell.pollenStorageGroup.remove(childrenPollens[i], true);
                          childrenPollens[i].destroy;
                          // console.log('childrenPollens[i]', childrenPollens[i]);
                      }

                      worker.scene.beeBreads.push( new BeeBreads(worker.scene, cell.x, cell.y) );

                  }
                  break;

              case 'honeyStorage':
                  if (worker.carryingNectar == true)
                  {
                      worker.carryingNectar = false;
                      cell.honeyStored += 1;
                  }
                  break;
          }
  }

  workerTouchedCellThatCanBeBuiltUponVertically(worker, cell)
  {
      if (worker.role == 'builder' && worker.isHungry == false && worker.recentlyTouchedBuilableCell == false)
      {

          worker.recentlyTouchedBuilableCell = true;
          worker.numberOfCellsWorkerCanBuildBeforeEating -= 1;
          if (worker.numberOfCellsWorkerCanBuildBeforeEating = 0)
          {
              worker.isHungry = true;
          }

          var builtCell;

          // New cell gets created above or below the cell.
          switch (cell.columnDirection)
          {
              case 'up':
                  cell.scene.cells.push( builtCell = new Cells(
                      cell.scene,
                      cell.x,
                      cell.y - (cell.height - 5),
                      this,
                      'empty',
                      true,
                      cell.columnDirection
                  ) );
                  break;
              case 'down':
                  cell.scene.cells.push( builtCell = new Cells(
                      cell.scene,
                      cell.x,
                      cell.y + (cell.height - 5),
                      this,
                      'empty',
                      true,
                      cell.columnDirection
                  ) );
                  break;
          }

          // Newest cell can be a builder target.
          // builtCell.canBeBuiltUpon = true;
          // builtCell.direction = cell.direction;
          builtCell.debugBodyColor = 0;
          cell.scene.cellsThatCanBeBuiltUponVerticallyGroup.add(builtCell.cellSprite);

          // Touched cell is no longer buildable.
          cell.canBeBuiltUpon = false;
          cell.debugBodyColor = 16711935;
          cell.scene.cellsThatCanBeBuiltUponVerticallyGroup.remove(cell);

          // Builder changes target to new buildable cell.
          // worker.target = Phaser.Math.RND.pick(worker.scene.cellsThatCanBeBuiltUponVerticallyGroup.children.entries);

          var recentlyChangedTargetTimer = worker.scene.time.addEvent(
              {
                  delay: 5000,
                  callback: function targetNoLongerRecentlyChanged() {
                      worker.recentlyTouchedBuilableCell = false;
                  },

                  callbackScope: this,
                  loop: false
              }
          );

          if (worker.scene.honeysGroup.children.entries.length > 0)
          {
              worker.target = Phaser.Math.RND.pick(worker.scene.honeysGroup.children.entries);
          } else
          {
              worker.target = Phaser.Math.RND.pick(worker.scene.cellsGroup.children.entries);
          }

      } else if (worker.role == 'builder' && worker.isHungry == true)
      {
          if (worker.scene.honeysGroup.children.entries.length > 0)
          {
              worker.target = Phaser.Math.RND.pick(worker.scene.honeysGroup.children.entries);
          } else if (worker.recentlyChangedTargetTimer == false)
          {
              worker.target = Phaser.Math.RND.pick(worker.scene.cellsGroup.children.entries);
          }
      }
  }

  workerTouchedCellThatCanBeBuiltUponToTheRight(worker, cell)
  {
      if (worker.role == 'builder' && worker.isHungry == false && worker.recentlyTouchedBuilableCell == false)
      {
          worker.recentlyTouchedBuilableCell = true;
          worker.numberOfCellsWorkerCanBuildBeforeEating -= 1;
          if (worker.numberOfCellsWorkerCanBuildBeforeEating = 0)
          {
              worker.isHungry = true;
          }

          var builtCell;

          // New cell gets created to the right of the cell.
          cell.scene.cells.push( builtCell = new Cells(
              cell.scene,
              cell.x + (cell.width + 18),
              cell.y - (cell.height - 5),
              this,
              'empty',
              true,
              cell.columnDirection
          ) );

          // Newest cell can be a builder target.
          // builtCell.canBeBuiltUpon = true;
          // builtCell.direction = cell.direction;
          builtCell.debugBodyColor = 0;
          builtCell.columnNumber = cell.columnNumber + 1;
          cell.scene.cellsThatCanBeBuiltUponVerticallyGroup.add(builtCell.cellSprite);
          cell.scene.cellsThatCanBeBuiltUponToTheRightGroup.add(builtCell.cellSprite);

          // Touched cell is no longer buildable.
          cell.canBeBuiltUpon = false;
          cell.debugBodyColor = 16711935;
          cell.scene.cellsThatCanBeBuiltUponVerticallyGroup.remove(cell);
          cell.scene.cellsThatCanBeBuiltUponToTheRightGroup.remove(cell);

          // Cells in the same column as the touched cell are no longer buildable to the right.
          var childrenCellsBuildableToTheRight = cell.scene.cellsThatCanBeBuiltUponToTheRightGroup.getChildren();
          for (var i = 0; i < childrenCellsBuildableToTheRight.length; i++)
          {
              if (cell.columnNumber == childrenCellsBuildableToTheRight[i].columnNumber)
              {
                  cell.scene.cellsThatCanBeBuiltUponToTheRightGroup.remove(childrenCellsBuildableToTheRight[i]);
              }
          }

          var recentlyChangedTargetTimer = worker.scene.time.addEvent(
              {
                  delay: 5000,
                  callback: function targetNoLongerRecentlyChanged() {
                      worker.recentlyTouchedBuilableCell = false;
                  },

                  callbackScope: this,
                  loop: false
              }
          );

          // Worker changes target to honey
          if (worker.scene.honeysGroup.children.entries.length > 0)
          {
              worker.target = Phaser.Math.RND.pick(worker.scene.honeysGroup.children.entries);
          } else if (worker.recentlyChangedTargetTimer == false)
          {
              worker.target = Phaser.Math.RND.pick(worker.scene.cellsGroup.children.entries);
          }

      } else if (worker.role == 'builder' && worker.isHungry == true)
      {
          if (worker.scene.honeysGroup.children.entries.length > 0)
          {
              worker.target = Phaser.Math.RND.pick(worker.scene.honeysGroup.children.entries);
          }
          else if (worker.recentlyChangedTargetTimer == false)
          {
              worker.target = Phaser.Math.RND.pick(worker.scene.cellsGroup.children.entries);
          }
      }
  }

  workerTouchedCellThatCanBeBuiltUponToTheLeft(worker, cell)
  {
      if (worker.role == 'builder' && worker.isHungry == false && worker.recentlyTouchedBuilableCell == false)
      {
          worker.recentlyTouchedBuilableCell = true;
          worker.numberOfCellsWorkerCanBuildBeforeEating -= 1;
          if (worker.numberOfCellsWorkerCanBuildBeforeEating = 0)
          {
              worker.isHungry = true;
          }

          var builtCell;

          // New cell gets created to the right of the cell.
          cell.scene.cells.push( builtCell = new Cells(
              cell.scene,
              cell.x - (cell.width - 18),
              cell.y + 25,
              this,
              'empty',
              true,
              cell.columnDirection
          ) );

          // Newest cell can be a builder target.
          // builtCell.canBeBuiltUpon = true;
          // builtCell.direction = cell.direction;
          builtCell.debugBodyColor = 0;
          builtCell.columnNumber = cell.columnNumber - 1;
          cell.scene.cellsThatCanBeBuiltUponVerticallyGroup.add(builtCell.cellSprite);
          cell.scene.cellsThatCanBeBuiltUponToTheLeftGroup.add(builtCell.cellSprite);

          // Touched cell is no longer buildable.
          cell.canBeBuiltUpon = false;
          cell.debugBodyColor = 16711935;
          cell.scene.cellsThatCanBeBuiltUponVerticallyGroup.remove(cell);
          cell.scene.cellsThatCanBeBuiltUponToTheLeftGroup.remove(cell);

          // Cells in the same column as the touched cell are no longer buildable to the right.
          var childrenCellsBuildableToTheLeft = cell.scene.cellsThatCanBeBuiltUponToTheLeftGroup.getChildren();
          for (var i = 0; i < childrenCellsBuildableToTheLeft.length; i++)
          {
              if (cell.columnNumber == childrenCellsBuildableToTheLeft[i].columnNumber)
              {
                  cell.scene.cellsThatCanBeBuiltUponToTheLeftGroup.remove(childrenCellsBuildableToTheLeft[i]);
              }
          }

          // Worker changes target to new buildable cell.
          // worker.target = Phaser.Math.RND.pick(worker.scene.cellsThatCanBeBuiltUponVerticallyGroup.children.entries);

          var recentlyChangedTargetTimer = worker.scene.time.addEvent(
              {
                  delay: 5000,
                  callback: function targetNoLongerRecentlyChanged() {
                      worker.recentlyTouchedBuilableCell = false;
                  },

                  callbackScope: this,
                  loop: false
              }
          );

          if (worker.scene.honeysGroup.children.entries.length > 0)
          {
              worker.target = Phaser.Math.RND.pick(worker.scene.honeysGroup.children.entries);
          } else
          {
              worker.target = Phaser.Math.RND.pick(worker.scene.cellsGroup.children.entries);
          }

      } else if (worker.role == 'builder' && worker.isHungry == true)
      {
          if (worker.scene.honeysGroup.children.entries.length > 0)
          {
              worker.target = Phaser.Math.RND.pick(worker.scene.honeysGroup.children.entries);
          } else if (worker.recentlyChangedTargetTimer == false)
          {
              worker.target = Phaser.Math.RND.pick(worker.scene.cellsGroup.children.entries);
          }
      }
  }

  queenBeeEggLayTouchedCell (queenBeeEggLay, cell)
  {

      // If this is the first time this has run, create preview sprite.
      if (!queenBeeEggLay.previousTouchedCell)
      {
          // queenBeeEggLay.eggPreviewSprite = cell.scene.physics.add.sprite(cell.x, cell.y, 'sprites', 'egg.png');
          // queenBeeEggLay.eggPreviewSprite.tint = 0xafd5aa;
          // queenBeeEggLay.eggPreviewSprite.alpha = 0.5;
          // var eggPreviewSpritePulsingTween = queenBeeEggLay.scene.tweens.add({
          //     targets: queenBeeEggLay.eggPreviewSprite,
          //     alpha: '0.1',
          //     duration: 500,
          //     ease: 'Sine',
          //     yoyo: true,
          //     repeat: -1
          // });
          // cell.scene.queenBeesGroup.add(queenBeeEggLay.eggPreviewSprite);
          // cell.tint = 0xafd5aa;
          // cell.containsEggPreview = true;

      }

      // If this is not the first time this has run.
      // if (queenBeeEggLay.previousTouchedCell)
      // {
      //     queenBeeEggLay.eggPreviewSprite.x = cell.x;
      //     queenBeeEggLay.eggPreviewSprite.y = cell.y;
      //     cell.containsEggPreview = true;
      //     cell.tint = 0xafd5aa;
      //     queenBeeEggLay.previousTouchedCell.tint = 16777215;
      //     queenBeeEggLay.previousTouchedCell.containsEggPreview = false;
      // }
      //
      // cell.scene.selectedEggLayCell = cell;
      // queenBeeEggLay.previousTouchedCell = cell;

  }

  pollenStartsToDie (pollen)
  {
      pollen.scene.tweens.add({
          targets: [pollen],
          alpha: 0,
          delay: 30000,
          duration: 3000,
          ease: 'Sine',
          onComplete:
              this.pollenDies,
      });
  }

  pollenDies(tween, target) {
      target[0].scene.pollensGroup.remove(target[0]);
      target[0].destroy();
  }

  closestEmptyCell(scene, source)
  {
      var min = Number.MAX_VALUE;
      var closest = null;
      var x = source.x;
      var y = source.y;

      for (var i = scene.cells.length - 1; i >= 0; i--)
      {
          var target = scene.cells[i].cellSprite;

          var distance = Phaser.Math.Distance.Between(x, y, target.x, target.y);

          // If this is the shortest distance so far, it's closest.
          if (distance < min &&
              target.typeOfCell == 'empty')
          {
              closest = target;
              min = distance;
          }
      }

      return closest;
  }

  update()
  {

      this.queenBees.forEach(function(queenBee)
      {
          queenBee.update(queenBee);
      });

      this.workers.forEach(function(worker)
      {
          worker.update(worker);
      });

      this.wasps.forEach(function(wasp)
      {
          wasp.update(wasp);
      });

  }

}

export default LobbyScene;

var QueenBees = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function QueenBees (scene, x, y)
    {
        // console.log("this is: ", this);
        // console.log("GameScene is: ", GameScene);
        // console.log("Phaser is: ", Phaser);
        // console.log("scene is: ", scene);

        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;
        this.isBot = true;
        this.enableSpine = true;

        // this.classType = QueenBee;
        this.queenBeeShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'queenBee.png');
        this.queenBeeShadowSprite.tint = 0x3c2040;
        this.queenBeeShadowSprite.alpha = .1;

        this.queenBeeSprite = scene.physics.add.sprite(x, y, 'sprites', 'queenBee.png');

        this.queenBeeSprite.setSize(70, 70).setCollideWorldBounds(true);
        this.queenBeeSprite.setBounce(1, 1).setBounce(1, 1).setMass(100000);
        this.queenBeeSprite.body.stopVelocityOnCollide = false;

        if (this.enableSpine)
        {
            this.queenBeeSprite.enableSpine = this.enableSpine;
            this.queenBeeSprite.setAlpha(0);
            // Create Spine object
            this.queenBeeSpine = scene.add.spine(400, 600, 'worker', 'flying', true);
            this.queenBeeSpine.setDepth(10);

            let selectedSkin;
            selectedSkin = this.queenBeeSpine.skeletonData.skins.find(skin => skin.name == "melliferaQueen");
            this.queenBeeSpine.setSkin(selectedSkin);
            this.queenBeeSpine.setScale(.3);
        }

        this.queenBeeEggLaySprite = scene.physics.add.sprite(x, y, 'sprites', 'egg.png');
        this.queenBeeEggLaySprite.alpha = 0;
        this.queenBeeEggLaySprite.setDisplayOrigin(-75, 10);

        scene.queenBeesGroup.add(this.queenBeeSprite);
        scene.queenBeesGroup.add(this.queenBeeEggLaySprite);
        scene.queenBeeEggLaysGroup.add(this.queenBeeEggLaySprite);

        this.followPheromoneActive = false;
        this.inputGiven = false;
        this.doOnce = 0;

        scene.input.keyboard.on('keydown_F', function (event) {
            console.log(this);
            scene.queenBees[0].followPheromoneActive = !scene.queenBees[0].followPheromoneActive;
        });

        // Bot variables
        if (this.isBot)
        {
            this.queenBeeSprite.targetRecentlyChanged = false;
            this.recentlyLaidEgg = false;
            this.recentlyPlacedNewHive = false;
            scene.queenBeeBotsGroup.add(this.queenBeeSprite);
            this.dangerZone = 750;

            let that = this;
            setTimeout(function()
            {
                // that.queenBeeSprite.target = scene.closestEmptyCell(scene, that.queenBeeSprite);
                // that.queenBeeSprite.task = "headingToNearestCell";
                that.botNewDestination(that);
                that.queenBeeSprite.task = "headingToNewDestination";
            }, 10);



        }

        scene.cameras.main.startFollow(this.queenBeeSprite);
    },

    update: function (queenBee)
    {
        // // Deal with pointers (mouse and touch).
        // if (this.scene.input.manager.activePointer.isDown == true)
        // {
        //     queenBee.queenBeeSprite._rotation = this.scene.physics.moveTo(
        //         queenBee.queenBeeSprite,
        //         this.scene.input.manager.activePointer.position.x + this.scene.cameras.main.scrollX,
        //         this.scene.input.manager.activePointer.position.y + this.scene.cameras.main.scrollY,
        //         200
        //     );
        // }
        //
        // // Deal with forward and backward.
        //  else if (queenBee.scene.cursors.up.isDown)
        // {
        //    queenBee.scene.physics.velocityFromAngle(queenBee.queenBeeSprite.angle, 200, queenBee.queenBeeSprite.body.velocity);
        // }
        // else if (queenBee.scene.cursors.down.isDown)
        // {
        //     queenBee.scene.physics.velocityFromAngle(queenBee.queenBeeSprite.angle, -200, queenBee.queenBeeSprite.body.velocity);
        // } else {
        //     queenBee.queenBeeSprite.setVelocityX(0);
        //     queenBee.queenBeeSprite.setVelocityY(0);
        // }
        //
        // // Deal with left and right turning.
        // if (queenBee.scene.cursors.left.isDown)
        // {
        //     queenBee.queenBeeSprite.setAngularVelocity(-100);
        // }
        // else if (queenBee.scene.cursors.right.isDown)
        // {
        //     queenBee.queenBeeSprite.setAngularVelocity(100);
        // } else {
        //     queenBee.queenBeeSprite.setAngularVelocity(0);
        // }

        // Bot Behavior
        if (queenBee.isBot)
        {
            let speed = 200;
            let acceleration = speed * .5;
            // Behave differently depending on task.
            switch(queenBee.queenBeeSprite.task)
            {
                case "headingToNearestCell":
                    if (queenBee.queenBeeSprite.target != null)
                    {
                        queenBee.queenBeeSprite._rotation = this.scene.physics.accelerateToObject(
                            queenBee.queenBeeSprite,
                            queenBee.queenBeeSprite.target,
                            acceleration,
                            speed,
                            speed
                        );
                    } else {
                        queenBee.queenBeeSprite.target = queenBee.scene.closestEmptyCell(queenBee.scene, queenBee.queenBeeSprite);
                    }
                    break;
                case "layingEggs":
                    if (!queenBee.queenBeeSprite.target ||
                        queenBee.queenBeeSprite.target == null)
                    {
                        queenBee.queenBeeSprite.target = queenBee.scene.closestEmptyCell(queenBee.scene, queenBee.queenBeeSprite);
                        if (queenBee.queenBeeSprite.target == null)
                        {
                            queenBee.queenBeeSprite.task = "headingToNewHiveLocation";
                            // console.log("headingToNewHiveLocation");
                        }
                    } else {
                        queenBee.queenBeeSprite._rotation = this.scene.physics.accelerateToObject(
                            queenBee.queenBeeSprite,
                            queenBee.queenBeeSprite.target,
                            10,
                            10,
                            10
                        );
                    }

                    if (queenBee.recentlyLaidEgg == false)
                    {
                        queenBee.botLayEgg(queenBee);
                        queenBee.queenBeeSprite.target = queenBee.scene.closestEmptyCell(queenBee.scene, queenBee.queenBeeSprite);
                        if (queenBee.queenBeeSprite.target != null)
                        {
                            let distanceToClosestEmptyCell = Phaser.Math.Distance.Between(
                                queenBee.queenBeeSprite.x,
                                queenBee.queenBeeSprite.y,
                                queenBee.queenBeeSprite.target.x,
                                queenBee.queenBeeSprite.target.y
                            );
                            if (distanceToClosestEmptyCell < 500)
                            {
                                queenBee.queenBeeSprite.task = "headingToNearestCell";
                            } else {
                                queenBee.queenBeeSprite.task = "headingToNewHiveLocation";
                                // console.log("headingToNewHiveLocation");
                            }
                        } else {
                            // console.log("No empty cells available.");
                        }
                    }
                    break;
                case "headingToNewHiveLocation":
                    if (!queenBee.queenBeeSprite.newHiveDestinationX ||
                        !queenBee.queenBeeSprite.newHiveDestinationY)
                    {
                        queenBee.queenBeeSprite.newHiveDestinationX = Phaser.Math.RND.integerInRange(-250,250);
                        queenBee.queenBeeSprite.newHiveDestinationY = Phaser.Math.RND.integerInRange(-250,250);
                    }
                    queenBee.queenBeeSprite._rotation = this.scene.physics.accelerateTo(
                        queenBee.queenBeeSprite,
                        queenBee.queenBeeSprite.newHiveDestinationX,
                        queenBee.queenBeeSprite.newHiveDestinationY,
                        acceleration,
                        speed,
                        speed
                    );
                    let distanceToNewHiveDestination = Phaser.Math.Distance.Between(
                        queenBee.queenBeeSprite.x,
                        queenBee.queenBeeSprite.y,
                        queenBee.queenBeeSprite.newHiveDestinationX,
                        queenBee.queenBeeSprite.newHiveDestinationY
                    );
                    if (distanceToNewHiveDestination < 200 && !queenBee.recentlyPlacedNewHive)
                    {
                        queenBee.botNewHive(queenBee);
                    }
                    break;
                case "headingToNewDestination":
                    if (!queenBee.queenBeeSprite.newDestinationX ||
                        !queenBee.queenBeeSprite.newDestinationY)
                    {
                        queenBee.botNewDestination(queenBee);
                    }
                    queenBee.queenBeeSprite._rotation = this.scene.physics.accelerateTo(
                        queenBee.queenBeeSprite,
                        queenBee.queenBeeSprite.newDestinationX,
                        queenBee.queenBeeSprite.newDestinationY,
                        acceleration,
                        speed,
                        speed
                    );
                    let distanceToNewDestination = Phaser.Math.Distance.Between(
                        queenBee.queenBeeSprite.x,
                        queenBee.queenBeeSprite.y,
                        queenBee.queenBeeSprite.newDestinationX,
                        queenBee.queenBeeSprite.newDestinationY
                    );
                    if (distanceToNewDestination < 20)
                    {
                        queenBee.botNewDestination(queenBee);
                    }
                    break;
                default:
                    // console.log("Queenbee bot has no task. Heading to nearest cell.");
                    queenBee.queenBeeSprite.task = "headingToNearestCell";
                    break;
            }

        }

        // Adjust position of shadow sprite.
        var offset = 10;
        queenBee.queenBeeShadowSprite.x = queenBee.queenBeeSprite.x + offset;
        queenBee.queenBeeShadowSprite.y = queenBee.queenBeeSprite.y + offset;
        queenBee.queenBeeShadowSprite.angle = queenBee.queenBeeSprite.angle;

        if (queenBee.enableSpine)
        {
            // Adjust position of spine object
            this.queenBeeSpine.setX(queenBee.queenBeeSprite.x);
            this.queenBeeSpine.setY(queenBee.queenBeeSprite.y);
            this.queenBeeSpine.setAngle(queenBee.queenBeeSprite.angle);
        }

        // Adjust position of Egg Lay Sprite
        queenBee.queenBeeEggLaySprite.setX(queenBee.queenBeeSprite.x);
        queenBee.queenBeeEggLaySprite.setY(queenBee.queenBeeSprite.y);
        queenBee.queenBeeEggLaySprite.setAngle(queenBee.queenBeeSprite.angle);
        // queenBee.queenBeeEggLaySprite.body.reset(queenBee.queenBeeSprite.x, queenBee.queenBeeSprite.y);


        // queenBee.queenBeeEggLaySprite.body.x = queenBee.queenBeeEggLaySprite.x;
        // queenBee.queenBeeEggLaySprite.body.y = queenBee.queenBeeEggLaySprite.y;
        // queenBee.queenBeeEggLaySprite.body.angle = queenBee.queenBeeEggLaySprite.angle;
    },

    botLayEgg: function (queenBee)
    {
        let closestCellToBot = queenBee.scene.closestEmptyCell(queenBee.scene, queenBee.queenBeeSprite);
        if (closestCellToBot && closestCellToBot.typeOfCell == 'empty')
        {

            closestCellToBot.typeOfCell = 'brood';
            queenBee.scene.broods.push( new Broods(
                queenBee.scene,
                closestCellToBot.x,
                closestCellToBot.y,
                'egg.png',
                queenBee.username,
                closestCellToBot)
            );
            queenBee.scene.setDepthOfGroups(queenBee.scene);
            queenBee.recentlyLaidEgg = true;
            setTimeout(function()
            {
                queenBee.recentlyLaidEgg = false;
                queenBee.queenBeeSprite.task = "headingToNearestCell";
                // console.log("Bot no longer recently laid egg.");
            }, 3000);
        } else {
            // console.log('There are no empty cells.');
        }
    },

    botNewHive: function (queenBee)
    {
        queenBee.scene.hives.push( new Hives(
            queenBee.scene,
            queenBee.queenBeeSprite.x,
            queenBee.queenBeeSprite.y)
        );
        queenBee.scene.setDepthOfGroups(queenBee.scene);
        queenBee.recentlyPlacedNewHive = true;
        setTimeout(function()
        {
            queenBee.recentlyPlacedNewHive = false;
        }, 3000);
        queenBee.queenBeeSprite.newHiveDestinationX = null;
        queenBee.queenBeeSprite.newHiveDestinationY = null;
        queenBee.queenBeeSprite.target = queenBee.scene.closestEmptyCell(queenBee.scene, queenBee.queenBeeSprite);
        queenBee.queenBeeSprite.task = "headingToNearestCell";
    },

    botNewDestination: function (queenBee)
    {
        queenBee.queenBeeSprite.newDestinationX = Phaser.Math.RND.integerInRange(-250,250);
        queenBee.queenBeeSprite.newDestinationY = Phaser.Math.RND.integerInRange(-250,250);
    }

});

var Workers = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Workers (scene, x, y)
    {

        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;

        this.enableSpine = true;

        // Add shadow
        this.workerShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'worker.png');
        this.workerShadowSprite.tint = 0x3c2040;
        this.workerShadowSprite.alpha = .1;

        // Add main sprite
        this.workerSprite = scene.physics.add.sprite(x, y, 'sprites', 'worker.png');
        scene.workersGroup.add(this.workerSprite);
        this.workerSprite.setBounce(1, 1);
        this.workerSprite.setSize(50);
        this.workerSprite.body.stopVelocityOnCollide = false;

        if (this.enableSpine)
        {
            this.workerSprite.enableSpine = this.enableSpine;
            this.workerSprite.setAlpha(0);
            // Create Spine object
            this.workerSpine = scene.add.spine(400, 600, 'worker', 'flying', true);
            this.workerSpine.setDepth(10);

            let selectedSkin;
            selectedSkin = this.workerSpine.skeletonData.skins.find(skin => skin.name == "mellifera");
            this.workerSpine.setSkin(selectedSkin);
            this.workerSpine.setScale(.25);
        }

        // What is this bee carrying?
        this.workerSprite.carryingNectar = false;
        this.workerSprite.carryingBeeBread = false;
        this.workerSprite.pollenCarriedGroup = scene.physics.add.group();
        this.workerSprite.beeBreadCarriedGroup = scene.physics.add.group();
        scene.physics.add.overlap(this.workerSprite.beeBreadCarriedGroup, scene.broodsGroup, scene.beeBreadTouchedBrood);
        this.workerSprite.pollenCarriedGroup.setDepth(0);
        this.workerSprite.beeBreadCarriedGroup.setDepth(0);

        // What are this bee's needs?
        this.workerSprite.isHungry = true;

        this.workerSprite.numberOfCellsWorkerCanBuildBeforeEating = 0;

        // Create role selection sprites.
        this.workerSprite.selectorSprite = scene.physics.add.sprite(x, y, 'sprites', 'beeSelector.png');

        // What is this bee's job?
        var randomRole = Phaser.Math.RND.pick(scene.workerRoles);
        this.workerSprite.role = randomRole;
        this.workerSprite.targetRecentlyChanged = false;
        this.workerSprite.recentlyTouchedBuilableCell = false;
        switch (this.workerSprite.role)
        {
            case 'forager':
                this.workerSprite.target = Phaser.Math.RND.pick(scene.plantsGroup.children.entries);
                this.workerSprite.selectorForagerSprite = scene.physics.add.sprite(x, y, 'sprites', 'foragerActive.png');
                this.workerSprite.selectorNurseSprite = scene.physics.add.sprite(x, y, 'sprites', 'nurseInactive.png');
                this.workerSprite.selectorBuilderSprite = scene.physics.add.sprite(x, y, 'sprites', 'builderInactive.png');
                // this.workerSprite.starterJob = this.workerSprite.jobForagerText;
                break;
            case 'nurse':
                this.workerSprite.target = Phaser.Math.RND.pick(scene.cellsGroup.children.entries);
                this.workerSprite.selectorForagerSprite = scene.physics.add.sprite(x, y, 'sprites', 'foragerInactive.png');
                this.workerSprite.selectorNurseSprite = scene.physics.add.sprite(x, y, 'sprites', 'nurseActive.png');
                this.workerSprite.selectorBuilderSprite = scene.physics.add.sprite(x, y, 'sprites', 'builderInactive.png');
                // this.workerSprite.starterJob = this.workerSprite.jobNurseText;
                break;
            case 'builder':
                this.workerSprite.target = Phaser.Math.RND.pick(scene.cellsGroup.children.entries);
                this.workerSprite.selectorForagerSprite = scene.physics.add.sprite(x, y, 'sprites', 'foragerInactive.png');
                this.workerSprite.selectorNurseSprite = scene.physics.add.sprite(x, y, 'sprites', 'nurseInactive.png');
                this.workerSprite.selectorBuilderSprite = scene.physics.add.sprite(x, y, 'sprites', 'builderActive.png');
                // this.workerSprite.starterJob = this.workerSprite.jobBuilderText;
                break;
        }

        this.workerSprite.selectorForagerSprite.setOrigin(0.5, 0);
        this.workerSprite.selectorNurseSprite.setOrigin(0.5, 0);
        this.workerSprite.selectorBuilderSprite.setOrigin(0.5, 0);

        this.workerSprite.selectorForagerSprite.alpha = 0;
        this.workerSprite.selectorNurseSprite.alpha = 0;
        this.workerSprite.selectorBuilderSprite.alpha = 0;
        this.workerSprite.selectorSprite.alpha = 0;

        scene.workerSelectionSpritesGroup.add(this.workerSprite.selectorSprite);
        scene.workerSelectionSpritesGroup.add(this.workerSprite.selectorForagerSprite);
        scene.workerSelectionSpritesGroup.add(this.workerSprite.selectorNurseSprite);
        scene.workerSelectionSpritesGroup.add(this.workerSprite.selectorBuilderSprite);

        // Set worker sprite click event.
        this.workerSprite.setInteractive();
        this.workerSprite.on('pointerdown', function () {

            var childrenWorkerSelectionSprites = scene.workerSelectionSpritesGroup.getChildren();
            for (var i = 0; i < childrenWorkerSelectionSprites.length; i++)
            {
                childrenWorkerSelectionSprites[i].alpha = 0;
            }
            this.scene.tweens.add({
                targets: [
                    this.selectorSprite,
                    this.selectorForagerSprite,
                    this.selectorNurseSprite,
                    this.selectorBuilderSprite,
                ],
                alpha: 1,
                duration: 250,
                ease: 'Sine'
            });

        })

        // Set a reference to the parent sprite on each button.
        this.workerSprite.selectorForagerSprite.parent = this.workerSprite;
        this.workerSprite.selectorNurseSprite.parent = this.workerSprite;
        this.workerSprite.selectorBuilderSprite.parent = this.workerSprite;

        // Set job selection click events.
        this.workerSprite.selectorForagerSprite.setInteractive();
        this.workerSprite.selectorForagerSprite.on('pointerdown', function () {
            if (this.frame.name == 'foragerInactive.png')
            {
                this.setTexture('sprites', 'foragerActive.png');
                this.parent.role = 'forager';
                this.parent.target = Phaser.Math.RND.pick(scene.plantsGroup.children.entries);
            } else {
                // this.setTexture('sprites', 'foragerInactive.png');
            }
            console.log('foragerSprite', this);
            this.parent.selectorNurseSprite.setTexture('sprites', 'nurseInactive.png');
            this.parent.selectorBuilderSprite.setTexture('sprites', 'builderInactive.png');
        });
        this.workerSprite.selectorNurseSprite.setInteractive();
        this.workerSprite.selectorNurseSprite.on('pointerdown', function () {
            if (this.frame.name == 'nurseInactive.png')
            {
                this.setTexture('sprites', 'nurseActive.png');
                this.parent.role = 'nurse';
                this.parent.target = Phaser.Math.RND.pick(scene.cellsGroup.children.entries);
            } else {
                // this.setTexture('sprites', 'nurseInactive.png');
            }
            this.parent.selectorForagerSprite.setTexture('sprites', 'foragerInactive.png');
            this.parent.selectorBuilderSprite.setTexture('sprites', 'builderInactive.png');
        });
        this.workerSprite.selectorBuilderSprite.setInteractive();
        this.workerSprite.selectorBuilderSprite.on('pointerdown', function () {
            if (this.frame.name == 'builderInactive.png')
            {
                this.setTexture('sprites', 'builderActive.png');
                this.parent.role = 'builder';
                this.parent.target = Phaser.Math.RND.pick(scene.cellsGroup.children.entries);
            } else {
                // this.setTexture('sprites', 'builderInactive.png');
            }
            this.parent.selectorForagerSprite.setTexture('sprites', 'foragerInactive.png');
            this.parent.selectorNurseSprite.setTexture('sprites', 'nurseInactive.png');
        });

    },

    update: function (worker)
    {
        try {
            // Follow the queen if her pheromone is active, otherwise head toward your own target.
            if (worker.scene.queenBees[0].followPheromoneActive)
            {
                worker.workerSprite._rotation = worker.scene.physics.accelerateToObject( worker.workerSprite, worker.scene.queenBees[0].queenBeeSprite, 120, 150, 150 );
            } else
            {
                worker.workerSprite._rotation = worker.scene.physics.accelerateToObject( worker.workerSprite, worker.workerSprite.target, 120, 100, 100 );
            }

            // Update the position of all the pollen carried by the bee.
            var childrenPollens = worker.workerSprite.pollenCarriedGroup.getChildren();
            for (var i = 0; i < childrenPollens.length; i++)
            {
                // console.log("childrenPollens", childrenPollens);
                childrenPollens[i].x = worker.workerSprite.x + childrenPollens[i].offsetWhenCarriedX;
                childrenPollens[i].y = worker.workerSprite.y + childrenPollens[i].offsetWhenCarriedY;
            }

            // Update the position of all the beeBread carried by the bee.
            var childrenBeeBreads = worker.workerSprite.beeBreadCarriedGroup.getChildren();
            for (var i = 0; i < childrenBeeBreads.length; i++)
            {
                childrenBeeBreads[i].x = worker.workerSprite.x;
                childrenBeeBreads[i].y = worker.workerSprite.y;
                childrenBeeBreads[i].angle = worker.workerSprite.angle;
            }

            // Adjust position of shadow sprite.
            var offset = 10;
            worker.workerShadowSprite.x = worker.workerSprite.x + offset;
            worker.workerShadowSprite.y = worker.workerSprite.y + offset;
            worker.workerShadowSprite.angle = worker.workerSprite.angle;

            if (worker.enableSpine)
            {
                // Adjust position of spine object
                this.workerSpine.setX(worker.workerSprite.x);
                this.workerSpine.setY(worker.workerSprite.y);
                this.workerSpine.setAngle(worker.workerSprite.angle);
            }

            // Adjust position of selector sprites.
            var offset = 10;
            worker.workerSprite.selectorSprite.x = worker.workerSprite.x;
            worker.workerSprite.selectorSprite.y = worker.workerSprite.y + offset;
            var xOffset = 60;
            worker.workerSprite.selectorForagerSprite.x = worker.workerSprite.x - xOffset;
            worker.workerSprite.selectorNurseSprite.x = worker.workerSprite.x;
            worker.workerSprite.selectorBuilderSprite.x = worker.workerSprite.x + xOffset;
            var yOffset = 75;
            worker.workerSprite.selectorForagerSprite.y = worker.workerSprite.y + yOffset;
            worker.workerSprite.selectorNurseSprite.y = worker.workerSprite.y + yOffset;
            worker.workerSprite.selectorBuilderSprite.y = worker.workerSprite.y + yOffset;

        } catch(e) {
        	console.log("There was an error updating the lobby scene: ", e);
        }
    },
});

var Hives = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Hives (scene, x, y)
    {

        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;

        this.cellSprites = [];
        this.hivesGroup = scene.physics.add.group();
        var numberOfColumns = Phaser.Math.RND.integerInRange(5,15);
        var columnDirection = '';
        var directions = ['up', 'down'];
        var yOffsetDirection = 'up';
        var startX = x;
        var startY = y;
        var currentCellInColumn;
        var previousCellInColumn;

        for (var h = 0; h < numberOfColumns; h++)
        {
            // Change X and Y for each column.
            if (h != 0)
            {
                if (yOffsetDirection == 'up')
                {
                    yOffsetDirection = 'down';
                    x += 35;
                    y -= 25;
                } else {
                    yOffsetDirection = 'up';
                    x += 35;
                    y += 25;
                }
            }

            // Remove build to the right status from previous column.
            if (h != 0)
            {
                var childrenCellsBuildableToTheRight = scene.cellsThatCanBeBuiltUponToTheRightGroup.getChildren();
                for (var i = 0; i < childrenCellsBuildableToTheRight.length; i++)
                {
                    scene.cellsThatCanBeBuiltUponToTheRightGroup.remove(childrenCellsBuildableToTheRight[i]);
                }
            }

            // First increase number of cells, then start decreasing them.
            if (h < (numberOfColumns/2))
            {
                cellsInColumn += 1;
            }
            else {
                cellsInColumn -= 1;
            }

            var cellsInColumn = Phaser.Math.RND.integerInRange(5,10);

            // Build cells up, then build them down.
            for (var j = 0; j < 2; j++)
            {

                switch(j)
                {
                    case 0:
                        columnDirection = 'up';
                        break;
                    case 1:
                        columnDirection = 'down';
                        break;
                }

                // Create cells in this column.
                for (var i = 0; i < cellsInColumn; i++)
                {

                    // Maybe this cell will have a grub in it, maybe it will be empty.
                    var willAGrubFillThisCell = Phaser.Math.RND.integerInRange(0,5);

                    if (willAGrubFillThisCell == 5)
                    {
                        var typeOfCell = 'brood';
                    } else
                    {
                        // Empty cell
                        var typeOfCell = 'empty';

                    }

                    // Place a cell, then work your way up or down adding cells from it.
                    switch(i) {
                        case 0:

                            scene.cells.push( currentCellInColumn = new Cells(
                                scene,
                                x,
                                y,
                                this,
                                typeOfCell,
                                true,
                                columnDirection
                            ) );

                            break;
                        default:
                            // var offset = 10;
                            if (columnDirection == 'up')
                            {
                                scene.cells.push( currentCellInColumn = new Cells(
                                    scene,
                                    x,
                                    previousCellInColumn.cellSprite.y - (previousCellInColumn.cellSprite.height - 5),
                                    this,
                                    typeOfCell,
                                    true,
                                    columnDirection
                                ) );

                            } else if (columnDirection == 'down')
                            {

                                scene.cells.push( currentCellInColumn = new Cells(
                                    scene,
                                    x,
                                    previousCellInColumn.cellSprite.y + (previousCellInColumn.cellSprite.height - 5),
                                    this,
                                    'empty',
                                    true,
                                    columnDirection
                                ) );

                            }
                            break;
                    }

                    // Set the column number of this cell.
                    currentCellInColumn.cellSprite.columnNumber = h;
                    if (currentCellInColumn.cellSprite.columnNumber != 0)
                    {
                        scene.cellsThatCanBeBuiltUponToTheRightGroup.add(currentCellInColumn.cellSprite);
                    } else
                    {
                        scene.cellsThatCanBeBuiltUponToTheLeftGroup.add(currentCellInColumn.cellSprite);
                    }

                    // Designate the latest cell in this column as able to be built upon vertically.
                    currentCellInColumn.cellSprite.body.debugBodyColor = 0;
                    scene.cellsThatCanBeBuiltUponVerticallyGroup.add(currentCellInColumn.cellSprite);

                    // Take away the latest status from the previous cell in this column.
                    if (previousCellInColumn && i != (cellsInColumn - 1))
                    {
                        previousCellInColumn.canBeBuiltUpon = false;
                        previousCellInColumn.cellSprite.body.debugBodyColor = 16711935;
                        scene.cellsThatCanBeBuiltUponVerticallyGroup.remove(previousCellInColumn.cellSprite);
                    }

                    // We are done with this cell, so set it as previous for the next one to reference.
                    previousCellInColumn = currentCellInColumn;
                }
            }




        }

    },

    update: function (time, delta)
    {

    }

});

var Cells = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Cells (scene, x, y, parentHive, typeOfCell, canBeBuiltUpon, columnDirection)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;

        this.parentHive = parentHive;
        this.typeOfCell = typeOfCell;
        this.canBeBuiltUpon = canBeBuiltUpon;
        this.columnDirection = columnDirection;

        var shadowOffset = 5;

        // Add shadow sprite
        this.cellSpriteShadow = scene.physics.add.image(
            x + shadowOffset,
            y + shadowOffset,
            'sprites', 'cell.png');
        this.cellSpriteShadow.tint = 0x3c2040;
        this.cellSpriteShadow.alpha = .1;
        // Shadow sprite scales in upon creation.
        this.cellSpriteShadow.scaleX = 0;
        this.cellSpriteShadow.scaleY = 0;
        scene.tweens.add({
            targets: this.cellSpriteShadow,
            scaleX: 1,
            scaleY: 1,
            duration: 1000,
            ease: 'Sine'
        });

        // Add main sprite
        this.cellSprite = scene.physics.add.image( x, y, 'sprites', 'cell.png' );
        // Sprite scales in upon creation.
        this.cellSprite.scaleX = 0;
        this.cellSprite.scaleY = 0;
        scene.tweens.add({
            targets: this.cellSprite,
            scaleX: 1,
            scaleY: 1,
            duration: 1000,
            ease: 'Sine'
        });

        scene.cellsGroup.add(this.cellSprite);
        scene.hivesGroup.add(this.cellSprite);

        this.cellSprite.typeOfCell = typeOfCell;
        this.cellSprite.columnDirection = columnDirection;
        this.cellSprite.honeyStored = 0;
        this.cellSprite.pollenStorageGroup = scene.add.group();
        this.cellSprite.honeyStorageGroup = scene.add.group();

        switch (typeOfCell) {
            case 'brood':
                scene.broods.push( new Broods(scene, this.cellSprite.x, this.cellSprite.y) );
                break;
        }


    },

    update: function (time, delta)
    {

    }

});

var GreenSpaces = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function GreenSpaces (scene, x, y, specieToSpawn)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;

        // var shadowOffset = 10;
        // this.greenSpaceShadowSprite = scene.physics.add.sprite(x + shadowOffset, y + shadowOffset, 'sprites', 'greenSpace.png');
        this.greenSpaceSprite = scene.physics.add.sprite(x, y, 'sprites', 'greenSpace.png');


        // if (!specieToSpawn)
        // {
        //     var specieToSpawn = 'any';
        // }
        //
        // var numberOfPlantsInThisGreenSpace = Phaser.Math.RND.integerInRange(5,20);
        // for (var i = 0; i < numberOfPlantsInThisGreenSpace; i++)
        // {
        //
        // }
        //
        // // Add main sprite
        // switch(specie) {
        //     case 'strawberry':
        //         // Add shadow
        //         this.plantShadowSprite = scene.physics.add.sprite(x + shadowOffset, y + shadowOffset, 'sprites', 'strawberry.png');
        //         this.plantSprite = scene.physics.add.sprite(x, y, 'sprites', 'strawberry.png');
        //         break;
        //     case 'lavender':
        //         this.plantShadowSprite = scene.physics.add.sprite(x + shadowOffset, y + shadowOffset, 'sprites', 'lavender.png');
        //         this.plantSprite = scene.physics.add.sprite(x, y, 'sprites', 'lavender.png');
        //         break;
        // }






        var numberOfPlantsOnThisPatch = 5;
        for (var i = 0; i < numberOfPlantsOnThisPatch; i++)
        {
            var randomX = Phaser.Math.RND.integerInRange(-550,550);
            var randomY = Phaser.Math.RND.integerInRange(-550,550);
            var randomPlantSpecie = Phaser.Math.RND.pick(scene.speciesOfPlant);
            scene.plants.push( new Plants(scene, this.greenSpaceSprite.x + randomX, this.greenSpaceSprite.y + randomY, randomPlantSpecie) );

        }





        // this.greenSpaceShadowSprite.tint = 0x3c2040;

        this.greenSpaceSprite.alpha = .5;
        // this.greenSpaceShadowSprite.alpha = .25;

        var randomAngle = Phaser.Math.RND.integerInRange(0,360);
        this.greenSpaceSprite.angle = randomAngle;
        // this.greenSpaceShadowSprite.angle = randomAngle;

        this.greenSpaceSprite.scaleX = 1.5;
        this.greenSpaceSprite.scaleY = 1.5;
        // this.greenSpaceShadowSprite.scaleX = 1.5;
        // this.greenSpaceShadowSprite.scaleY = 1.5;

        this.greenSpaceSprite.setMaxVelocity(0,0);

        scene.greenSpacesGroup.add(this.greenSpaceSprite);
        // scene.greenSpacesGroup.add(this.greenSpaceShadowSprite);
    },

    update: function (time, delta)
    {

    }

});

var Plants = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Plants (scene, x, y, specie)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;

        var shadowOffset = 10;

        this.enableSpine = true;

        // Add main sprite
        switch(specie) {
            case 'strawberry':
                // Add shadow
                this.plantShadowSprite = scene.physics.add.sprite(x + shadowOffset, y + shadowOffset, 'sprites', 'strawberry.png');
                this.plantSprite = scene.physics.add.sprite(x, y, 'sprites', 'strawberry.png');
                break;
            case 'lavender':
                this.plantShadowSprite = scene.physics.add.sprite(x + shadowOffset, y + shadowOffset, 'sprites', 'lavender.png');
                this.plantSprite = scene.physics.add.sprite(x, y, 'sprites', 'lavender.png');
                break;
            case 'foxglove':
                this.plantShadowSprite = scene.physics.add.sprite(x + shadowOffset, y + shadowOffset, 'sprites', 'foxglove.png');
                this.plantSprite = scene.physics.add.sprite(x, y, 'sprites', 'foxglove.png');
                break;
            case 'echinacea':
                this.plantShadowSprite = scene.physics.add.sprite(x + shadowOffset, y + shadowOffset, 'sprites', 'echinacea.png');
                this.plantSprite = scene.physics.add.sprite(x, y, 'sprites', 'echinacea.png');
                break;
        }

        this.plantShadowSprite.tint = 0x3c2040;
        this.plantShadowSprite.alpha = .1;

        var randomAngle = Phaser.Math.RND.integerInRange(0,360);
        this.plantShadowSprite.angle = randomAngle;
        this.plantSprite.angle = randomAngle;
        this.plantSprite.setMaxVelocity(0,0);

        if (this.enableSpine)
        {
            this.plantSprite.enableSpine = this.enableSpine;
            this.plantSprite.setAlpha(0);
            // Create Spine object
            let skin = specie;
            this.plantSpine = scene.add.spine(400, 600, skin, 'animation', true);
            this.plantSpine.setScale(.5);
            this.plantSpine.setX(this.plantSprite.x);
            this.plantSpine.setY(this.plantSprite.y);
            this.plantSpine.setAngle(this.plantSprite.angle);
            this.plantSpine.setDepth(7);
            this.plantSpine.timeScale = .2;
            // scene.plantsGroup.add(this.plantSpine);
        }

        scene.plantsGroup.add(this.plantSprite);
    },

    update: function (time, delta)
    {

    }

});

var Pollens = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Pollens (scene, x, y, specie)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;

        var pollenSprites = ['pollen2.png', 'pollen1.png'];
        var chosenSprite = Phaser.Math.RND.pick(pollenSprites);
        this.pollenSprite = scene.physics.add.sprite(x, y, 'sprites', chosenSprite);
        this.pollenSprite.setCircle(5).setFriction(0,0);
        // console.log(this.pollenSprite)

        // Pollen scales in upon creation
        this.pollenSprite.scaleX = 0;
        this.pollenSprite.scaleY = 0;
        scene.tweens.add({
            targets: this.pollenSprite,
            scaleX: 1,
            scaleY: 1,
            duration: 1000,
            ease: 'Sine'
        });

        scene.pollensGroup.add(this.pollenSprite);

        this.pollenSprite.offsetWhenCarriedX = Phaser.Math.RND.integerInRange(-20, 20);
        this.pollenSprite.offsetWhenCarriedY = Phaser.Math.RND.integerInRange(-20, 20);

        // Set a lifespan on the pollen.
        this.lifespanTimer = scene.time.delayedCall(60000, scene.pollenStartsToDie(this.pollenSprite), [], this);

    },

    update: function (time, delta)
    {

    }

});

var BeeBreads = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function BeeBreads (scene, x, y, specie)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;

        var beeBreadSprites = ['beeBread.png'];
        var chosenSprite = Phaser.Math.RND.pick(beeBreadSprites);
        this.beeBreadSprite = scene.physics.add.sprite(x, y, 'sprites', chosenSprite);
        this.beeBreadSprite.body.setCircle( this.beeBreadSprite.width/2 );

        // Bee Bread scales in upon creation
        this.beeBreadSprite.scaleX = 0;
        this.beeBreadSprite.scaleY = 0;
        scene.tweens.add({
            targets: this.beeBreadSprite,
            scaleX: 1,
            scaleY: 1,
            duration: 1000,
            ease: 'Sine'
        });

        scene.beeBreadsGroup.add(this.beeBreadSprite);

        this.beeBreadSprite.offsetWhenCarriedX = Phaser.Math.RND.integerInRange(-20, 20);
        this.beeBreadSprite.offsetWhenCarriedY = Phaser.Math.RND.integerInRange(-20, 20);

    },

    update: function (time, delta)
    {

    }

});

var Broods = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Broods (scene, x, y, developmentalStage)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;

        var developmentalStages = ['egg.png', 'larva.png', 'pupa.png'];

        if (!developmentalStage)
        {
            var developmentalStage = Phaser.Math.RND.pick(developmentalStages);
        } else {
            {
                var developmentalStage = developmentalStage;
            }
        }

        this.broodSprite = scene.physics.add.sprite(
            x,
            y,
            'sprites', developmentalStage
        );
        this.broodSprite.angle = Phaser.Math.RND.integerInRange(0,360);
        if (developmentalStage == 'larva.png')
        {
            var larvaSpinningTween = scene.tweens.add({
                targets: this.broodSprite,
                angle: '+=360',
                duration: 3000 + this.broodSprite.angle,
                ease: 'Sine',
                repeat: -1
            });
        } else if (developmentalStage == 'egg.png')
        {
            var eggWigglingTween = scene.tweens.add({
                targets: this.broodSprite,
                angle: '+=20',
                duration: 500 + this.broodSprite.angle,
                ease: 'Sine',
                yoyo: true,
                repeat: -1
            });
        }

        // Brood scales in upon creation
        this.broodSprite.scaleX = 0;
        this.broodSprite.scaleY = 0;
        scene.tweens.add({
            targets: this.broodSprite,
            scaleX: 1,
            scaleY: 1,
            duration: 1000,
            ease: 'Sine'
        });

        switch (developmentalStage)
        {
            case 'egg.png':
                this.broodSprite.broodStage = 'egg';
                scene.tweens.add({
                    targets: this.broodSprite,
                    alpha: '0',
                    delay: 2000,
                    duration: 500,
                    ease: 'Sine',
                    onComplete: this.eggGrowsIntoLarva
                });
                break;
            case 'larva.png':
                this.broodSprite.broodStage = 'larva';
                break;
            case 'pupa.png':
                this.broodSprite.broodStage = 'pupa';
                break;
        }

        scene.broodsGroup.add(this.broodSprite);



    },

    eggGrowsIntoLarva: function (tween, broodSprite)
    {
        // console.log('egg grew to larva', broodSprite);
        broodSprite[0].broodStage = 'larva';
        broodSprite[0].setTexture( 'sprites', 'larva.png');
        broodSprite[0].scene.tweens.add({
            targets: broodSprite[0],
            alpha: '1',
            duration: 500,
            ease: 'Sine',
        });
    },

    update: function (time, delta)
    {

    }

});

var Wasps = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Wasps (scene, x, y)
    {

        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;

        // Add shadow
        this.waspShadowSprite = scene.physics.add.sprite(x, y, 'sprites', 'wasp.png');
        this.waspShadowSprite.tint = 0x3c2040;
        this.waspShadowSprite.alpha = .1;

        // Add main sprite
        this.waspSprite = scene.physics.add.sprite(x, y, 'sprites', 'wasp.png');
        scene.waspsGroup.add(this.waspSprite);
        this.waspSprite.setBounce(1, 1);
        this.waspSprite.body.stopVelocityOnCollide = false;

        this.waspSprite.target = Phaser.Math.RND.pick(scene.queenBeesGroup.children.entries);
    },

    update: function (wasp)
    {

        wasp.waspSprite._rotation = wasp.scene.physics.accelerateToObject( wasp.waspSprite, wasp.waspSprite.target, 120, 100, 100 );

        // Adjust position of shadow sprite.
        var offset = 10;
        wasp.waspShadowSprite.x = wasp.waspSprite.x + offset;
        wasp.waspShadowSprite.y = wasp.waspSprite.y + offset;
        wasp.waspShadowSprite.angle = wasp.waspSprite.angle;


    },
});

var Logs = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Logs (scene, x, y, angle)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;

        var shadowOffset = 10;

        this.logShadowSprite = scene.physics.add.sprite(x + shadowOffset, y + shadowOffset, 'sprites', 'log.png');
        this.logSprite = scene.physics.add.sprite(x, y, 'sprites', 'log.png');

        this.logShadowSprite.tint = 0x3c2040;
        this.logShadowSprite.alpha = .1;
        this.logShadowSprite.angle = angle;

        this.logSprite.angle = angle
        this.logSprite.setMaxVelocity(0,0);

        scene.logsGroup.add(this.logSprite);
    },

    update: function (time, delta)
    {

    }

});

var Boulders = new Phaser.Class({

    Extends: Phaser.GameObjects.Image,

    initialize:

    function Boulders (scene, x, y, angle)
    {
        Phaser.GameObjects.Group.call(this, scene);

        this.scene = scene;

        var randomSprite = Phaser.Math.RND.pick(scene.boulderSprites);

        var shadowOffset = 10;

        this.boulderShadowSprite = scene.physics.add.sprite(x + shadowOffset, y + shadowOffset, 'sprites', randomSprite);
        this.boulderSprite = scene.physics.add.sprite(x, y, 'sprites', randomSprite);

        this.boulderShadowSprite.tint = 0x3c2040;
        this.boulderShadowSprite.alpha = .1;
        this.boulderShadowSprite.angle = angle;

        this.boulderSprite.angle = angle
        this.boulderSprite.setMaxVelocity(0,0);

        scene.bouldersGroup.add(this.boulderSprite);
    },

    update: function (time, delta)
    {

    }

});



// WEBPACK FOOTER //
// ./src/scenes/Lobby/LobbyScene.js